/**
 * Public Enrollment (Inscripción) View
 * Public multi-tab enrollment form. The school's names, logo and texts come from
 * Ajustes → Datos del centro (SchoolService).
 * Access: Public, anonymous.
 */

const InscripcionView = {
    token: null,
    formations: [],
    currentTab: 0,
    webcamStream: null,
    filesUploaded: {
        foto: null,
        dni: null,
        dniReverso: null,
        presentacion: null,
        estudios: null,
        justificantePago: null,
        dniFrontal: null,
        dniTrasera: null,
        solicitudFraccionado: null,
        declaracionIngresos: null
    },
    paymentMonths: 6,
    render(hash) {
        // Parse token if present in hash, e.g. inscribete/TOKEN-XYZ or inscribete?token=TOKEN-XYZ
        let token = null;
        if (hash) {
            const cleanHash = hash.replace(/^#\/?/, '');
            const slashParts = cleanHash.split('/');
            if (slashParts.length > 1 && slashParts[1]) {
                token = slashParts[1].split('?')[0].trim();
            } else if (cleanHash.includes('?')) {
                const queryStr = cleanHash.split('?')[1];
                const params = new URLSearchParams(queryStr);
                token = params.get('token');
            }
        }
        if (!token && window.location.search) {
            const params = new URLSearchParams(window.location.search);
            token = params.get('token');
        }
        // Tokens are server-issued (hex): anything else in the URL is ignored, never rendered.
        this.token = token && /^[a-zA-Z0-9-]{16,128}$/.test(token.trim()) ? token.trim() : null;

        return `
        <div class="public-enrollment-mode enrollment-editorial">
            <a class="ins-skip" href="#enrollmentContent">Saltar al formulario</a>
            <header class="ins-site-header">
                <div class="ins-school-brand">
                    ${SchoolService.logoHtml('logoLightUrl', 'class="ins-school-logo"')}
                    <span>${Utils.sanitizeHTML(SchoolService.name())}</span>
                </div>
                ${SchoolService.get('website') ? `<a href="${Utils.sanitizeHTML(SchoolService.get('website'))}" target="_blank" rel="noopener noreferrer">Volver a la escuela <span aria-hidden="true">↗</span></a>` : ''}
            </header>
            <section class="ins-introduction" aria-labelledby="ins-page-title">
                <div><p class="ins-eyebrow">Admisiones · ${Utils.sanitizeHTML(SchoolService.shortName())}</p>
                <h1 id="ins-page-title">Tu próximo paso,<br>en el cine.</h1></div>
                <div class="ins-introduction-copy"><p>Queremos conocerte. Cuéntanos qué te mueve y qué te gustaría aprender.</p>
                <span>Completa tu solicitud a tu ritmo. Puedes guardar un borrador y retomarlo más adelante.</span></div>
            </section>
            <div class="public-enrollment-container animate__animated animate__fadeIn">
                <div class="enrollment-card-main">
                    <form id="miFormulario" ${UIEvents.attr("submit", function(event,captured){event.preventDefault();}, [])} class="enrollment-form-grid">
                        
                        <!-- COLUMNA IZQUIERDA: SIDEBAR -->
                        <div class="enrollment-card-sidebar" id="enrollmentSidebar">
                            <div>
                                <p class="ins-eyebrow">Solicitud de admisión</p>
                                <h2 class="ins-sidebar-title">Vamos<br>paso a paso.</h2>

                                <!-- Stepper Vertical -->
                                <ul class="enrollment-stepper" id="matriculaTabs" aria-label="Pasos de la solicitud">
                                    <li class="tab-item active" data-tab="0" role="button" tabindex="0" aria-controls="pane-0">
                                        <div class="step-icon-circle">
                                            <span class="step-number">1</span>
                                            <i class="fas fa-check step-check-icon"></i>
                                        </div>
                                        <span class="tab-text"><span class="tab-label">Datos personales</span><span class="tab-desc">Formación e identidad</span></span>
                                    </li>
                                    <li class="tab-item" data-tab="1" role="button" tabindex="0" aria-controls="pane-1" id="tabTutorItem" style="display: none;">
                                        <div class="step-icon-circle">
                                            <span class="step-number">2</span>
                                            <i class="fas fa-check step-check-icon"></i>
                                        </div>
                                        <span class="tab-text"><span class="tab-label">Tutor/a</span><span class="tab-desc">Solo para menores</span></span>
                                    </li>
                                    <li class="tab-item" data-tab="2" role="button" tabindex="0" aria-controls="pane-2">
                                        <div class="step-icon-circle">
                                            <span class="step-number">3</span>
                                            <i class="fas fa-check step-check-icon"></i>
                                        </div>
                                        <span class="tab-text"><span class="tab-label">Contacto</span><span class="tab-desc">Dónde localizarte</span></span>
                                    </li>
                                    <li class="tab-item" data-tab="3" role="button" tabindex="0" aria-controls="pane-3">
                                        <div class="step-icon-circle">
                                            <span class="step-number">4</span>
                                            <i class="fas fa-check step-check-icon"></i>
                                        </div>
                                        <span class="tab-text"><span class="tab-label">Presentación</span><span class="tab-desc">Motivación y estudios</span></span>
                                    </li>
                                    <li class="tab-item" data-tab="4" role="button" tabindex="0" aria-controls="pane-4">
                                        <div class="step-icon-circle">
                                            <span class="step-number">5</span>
                                            <i class="fas fa-check step-check-icon"></i>
                                        </div>
                                        <span class="tab-text"><span class="tab-label">Confirmación</span><span class="tab-desc">Revisa y envía</span></span>
                                    </li>
                                </ul>
                            </div>

                            <!-- Footer del Sidebar con Guardar borrador -->
                            <div class="enrollment-draft-tools">
                                <button type="button" id="guardarBtn" class="btn-save-draft">
                                    <i class="far fa-save"></i> Guardar borrador
                                </button>
                                ${this.token ? `
                                    <div class="token-badge-sidebar">
                                        <i class="fas fa-key"></i> Borrador:<br><code>${Utils.sanitizeHTML(this.token)}</code>
                                    </div>
                                ` : `
                                    <div class="load-draft-container">
                                        <span class="load-draft-title">¿Tienes un borrador?</span>
                                        <div class="load-draft-input-group">
                                            <input type="text" aria-label="Código del borrador" id="tokenCargarInput" placeholder="Código de tu borrador" class="load-draft-input">
                                            <button type="button" id="cargarBorradorBtn" class="btn-load-draft" title="Recuperar borrador">
                                                <i class="fas fa-arrow-right"></i>
                                            </button>
                                        </div>
                                    </div>
                                `}
                            </div>
                        </div>

                        <!-- COLUMNA DERECHA: CONTENIDO -->
                        <div class="enrollment-card-content" id="enrollmentContent">
                            <div class="ins-progress" aria-hidden="true"><span id="insProgress"></span></div>
                            <div class="support-link">
                                ${SchoolService.get('contactUrl') || SchoolService.get('website') ? `¿Tienes dudas? <a href="${Utils.sanitizeHTML(SchoolService.get('contactUrl') || SchoolService.get('website'))}" target="_blank" rel="noopener noreferrer">Obtener Ayuda</a>` : SchoolService.get('contactEmail') ? `¿Tienes dudas? Escríbenos a ${Utils.sanitizeHTML(SchoolService.get('contactEmail'))}` : ''}
                            </div>

                            <div class="ins-step-heading"><p class="ins-eyebrow" id="insStepCounter">Paso 1 de 4</p><h2 id="insStepTitle" tabindex="-1">Tu formación y tus datos.</h2><p>Los campos marcados con * son obligatorios.</p></div>
                            <div class="tab-content-wrapper">
                                
                                <!-- TAB 0: Datos Personales (Incluye la Selección de Formación al inicio) -->
                                <div class="tab-pane active" id="pane-0">
                                    
                                    <!-- SELECCIÓN DE FORMACIÓN -->
                                    <div class="formation-selector-box">
                                        <h4 class="section-title-inside"><i class="fas fa-university"></i> Elige tu formación</h4>
                                        <div class="form-grid">
                                            <div class="form-group border-labeled">
                                                <label for="tipo_formation" class="form-label-overlay">Tipo de Formación *</label>
                                                <select id="tipo_formation" name="tipo_formation" class="form-select" required>
                                                    <option value="">-- Selecciona el Tipo --</option>
                                                </select>
                                            </div>
                                            <div class="form-group border-labeled" id="formation_select_group">
                                                <label for="formation_id" class="form-label-overlay">Elegir Curso *</label>
                                                <select id="formation_id" name="formation_id" class="form-select" required disabled>
                                                    <option value="">-- Selecciona primero el tipo --</option>
                                                </select>
                                            </div>
                                        </div>

                                        <!-- Ordenar preferencias (tipos con «el solicitante ordena sus preferencias») -->
                                        <div id="diplomatura_dnd" style="display: none; margin-top: 1.5rem;" class="animate__animated animate__fadeIn">
                                            <span class="form-label-overlay-static">Ordena tus especialidades por preferencia con las flechas o arrastrando:</span>
                                            <div id="dnd_container" class="dnd-list-box">
                                                <!-- Items will be generated here -->
                                            </div>
                                            <input type="hidden" id="orden_diplomaturas" name="orden_diplomaturas" value="">
                                            <input type="hidden" id="formation_id_diploma" name="formation_id_diploma" value="">
                                        </div>
                                    </div>

                                    <h4 class="section-title"><i class="far fa-id-card"></i> Datos Personales</h4>
                                    <p class="subtitle-desc">Introduce tus datos identificativos y fotografía oficial.</p>

                                    <div class="form-grid">
                                        <div class="form-group border-labeled">
                                            <label for="nombre" class="form-label-overlay">Nombre *</label>
                                            <input type="text" id="nombre" name="nombre" class="form-input" required maxlength="60" placeholder="Tu nombre">
                                        </div>
                                        <div class="form-group border-labeled">
                                            <label for="apellidos" class="form-label-overlay">Apellidos *</label>
                                            <input type="text" id="apellidos" name="apellidos" class="form-input" required maxlength="80" placeholder="Tus apellidos">
                                        </div>
                                        <div class="form-group border-labeled">
                                            <label for="dni" class="form-label-overlay">DNI / NIE / Pasaporte *</label>
                                            <input type="text" id="dni" name="dni" class="form-input" required placeholder="DNI o NIE">
                                        </div>
                                        <div class="form-group border-labeled">
                                            <label for="fecha_nacimiento" class="form-label-overlay">Fecha de Nacimiento *</label>
                                            <input type="date" id="fecha_nacimiento" name="fecha_nacimiento" class="form-input" required>
                                        </div>
                                        <div class="form-group">
                                             <span class="form-label-overlay-static">DNI · anverso *</span>
                                             <div class="upload-zone" id="zone-dni_subido">
                                                 <input type="file" id="dni_subido" accept="image/*,application/pdf" class="visually-hidden">
                                                 <label for="dni_subido" class="upload-zone-label">
                                                     <i class="fas fa-id-card upload-icon"></i>
                                                     <span class="upload-text">Subir cara delantera</span>
                                                     <span class="upload-hint">PDF o imagen (máx. 20 MB)</span>
                                                 </label>
                                                 <div id="dni_preview_link" class="file-preview-status"></div>
                                             </div>
                                             <button type="button" class="ins-camera-btn" data-camera-field="dni" hidden ${UIEvents.attr("click", function(event,captured){InscripcionView.captureId(String(captured[0]));}, ['dni'])}>
                                                 <i class="fas fa-camera"></i> Hacer foto de la cara delantera
                                             </button>
                                        </div>
                                        <div class="form-group">
                                             <span class="form-label-overlay-static">DNI · reverso *</span>
                                             <div class="upload-zone" id="zone-dni_reverso">
                                                 <input type="file" id="dni_reverso" accept="image/*,application/pdf" class="visually-hidden">
                                                 <label for="dni_reverso" class="upload-zone-label">
                                                     <i class="fas fa-id-card upload-icon"></i>
                                                     <span class="upload-text">Subir cara trasera</span>
                                                     <span class="upload-hint">PDF o imagen (máx. 20 MB)</span>
                                                 </label>
                                                 <div id="dni_reverso_preview_link" class="file-preview-status"></div>
                                             </div>
                                             <button type="button" class="ins-camera-btn" data-camera-field="dniReverso" hidden ${UIEvents.attr("click", function(event,captured){InscripcionView.captureId(String(captured[0]));}, ['dniReverso'])}>
                                                 <i class="fas fa-camera"></i> Hacer foto de la cara trasera
                                             </button>
                                        </div>
                                        <div class="form-group border-labeled">
                                            <label for="sexo" class="form-label-overlay">Sexo *</label>
                                            <select id="sexo" name="sexo" class="form-select" required>
                                                <option value="">Selecciona...</option>
                                                <option value="hombre">Hombre</option>
                                                <option value="mujer">Mujer</option>
                                                <option value="otro">Otro</option>
                                            </select>
                                        </div>
                                        <div class="form-group border-labeled">
                                            <label for="como_nos_conociste" class="form-label-overlay">¿Cómo nos conociste?</label>
                                            <select id="como_nos_conociste" name="como_nos_conociste" class="form-select">
                                                <option value="">Selecciona una opción...</option>
                                                <option value="Google / Buscador">Google / Buscador</option>
                                                <option value="Redes Sociales">Redes Sociales</option>
                                                <option value="Anuncio Online">Anuncio Online</option>
                                                <option value="Recomendación de un amigo">Recomendación de un amigo</option>
                                                <option value="Exalumno / Referido">Exalumno / Referido</option>
                                                <option value="Feria o evento">Feria o evento</option>
                                                <option value="Carteles o flyers">Carteles o flyers</option>
                                                <option value="Prensa o radio">Prensa o radio</option>
                                                <option value="Otro">Otro</option>
                                            </select>
                                        </div>
                                    </div>

                                    <h4 class="section-title" style="margin-top: 0.9rem;"><i class="fas fa-camera"></i> Foto del Alumno</h4>
                                    <div class="photo-capture-section">
                                        <div class="photo-preview-box">
                                            <div id="photo-placeholder" class="placeholder-overlay">
                                                <i class="far fa-user"></i>
                                                <span>Sin foto</span>
                                            </div>
                                            <img id="photo-image-preview" src="" style="display: none; width: 100%; height: 100%; object-fit: cover;">
                                            <video id="video" autoplay playsinline style="display: none;"></video>
                                            <canvas id="canvas" style="display: none;"></canvas>
                                            <input type="hidden" id="fotoBase64" name="fotoBase64">

                                            <!-- Viewfinder Overlay -->
                                            <div class="viewfinder-overlay" id="viewfinderOverlay" style="display: none;">
                                                <div class="viewfinder-corner top-left"></div>
                                                <div class="viewfinder-corner top-right"></div>
                                                <div class="viewfinder-corner bottom-left"></div>
                                                <div class="viewfinder-corner bottom-right"></div>
                                                <div class="viewfinder-grid">
                                                    <div class="grid-line horizontal"></div>
                                                    <div class="grid-line vertical"></div>
                                                </div>
                                                <div class="rec-indicator"><span class="pulse-dot"></span> LIVE</div>
                                            </div>
                                        </div>
                                        <div class="photo-controls">
                                            <div class="form-group" style="margin-bottom: 0;">
                                                 <span class="form-label-overlay-static">Subir desde dispositivo</span>
                                                 <div class="upload-zone photo-upload-zone" id="zone-foto_subida">
                                                     <input type="file" id="foto_subida" accept="image/*" class="visually-hidden">
                                                     <label for="foto_subida" class="upload-zone-label">
                                                         <i class="fas fa-image upload-icon"></i>
                                                         <span class="upload-text">Seleccionar Foto</span>
                                                         <span class="upload-hint">Imagen JPG/PNG (Máx. 20MB)</span>
                                                     </label>
                                                 </div>
                                            </div>
                                            <div class="camera-actions">
                                                 <button type="button" id="activarCamaraBtn" class="btn btn-activate-camera"><i class="fas fa-video"></i> Activar Cámara</button>
                                                 <button type="button" id="tomarFotoBtn" class="btn btn-shutter" style="display: none;"><i class="fas fa-camera"></i> Capturar</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- TAB 1: Datos del Tutor (Menores) -->
                                <div class="tab-pane" id="pane-1">
                                    <h4 class="section-title"><i class="fas fa-user-shield"></i> Datos del Tutor Legal</h4>
                                    <p class="subtitle-desc">Requerido de forma obligatoria para menores de 18 años.</p>
                                    
                                    <div class="form-grid">
                                        <div class="form-group border-labeled">
                                            <label for="nombreTutor" class="form-label-overlay">Nombre y apellidos del tutor *</label>
                                            <input type="text" id="nombreTutor" name="nombreTutor" class="form-input">
                                        </div>
                                        <div class="form-group border-labeled">
                                            <label for="telefonoTutor" class="form-label-overlay">Teléfono del tutor *</label>
                                            <input type="tel" id="telefonoTutor" name="telefonoTutor" class="form-input">
                                        </div>
                                        <div class="form-group border-labeled">
                                            <label for="dniTutor" class="form-label-overlay">DNI / Pasaporte del tutor *</label>
                                            <input type="text" id="dniTutor" name="dniTutor" class="form-input">
                                        </div>
                                        <div class="form-group border-labeled">
                                            <label for="emailTutor" class="form-label-overlay">E-mail del tutor *</label>
                                            <input type="email" id="emailTutor" name="emailTutor" class="form-input">
                                        </div>
                                        <div class="form-group border-labeled" style="grid-column: span 2;">
                                            <label for="direccionTutor" class="form-label-overlay">Dirección del tutor *</label>
                                            <input type="text" id="direccionTutor" name="direccionTutor" class="form-input">
                                        </div>
                                        <div class="form-group border-labeled">
                                            <label for="codigoPostalTutor" class="form-label-overlay">Código postal *</label>
                                            <input type="text" id="codigoPostalTutor" name="codigoPostalTutor" class="form-input">
                                        </div>
                                        <div class="form-group border-labeled">
                                            <label for="municipioTutor" class="form-label-overlay">Municipio del tutor *</label>
                                            <input type="text" id="municipioTutor" name="municipioTutor" class="form-input">
                                        </div>
                                        <div class="form-group border-labeled">
                                            <label for="provinciaTutor" class="form-label-overlay">Provincia del tutor *</label>
                                            <select id="provinciaTutor" name="provinciaTutor" class="form-select">
                                                <option value="">Selecciona...</option>
                                                <option value="Álava">Álava</option><option value="Albacete">Albacete</option><option value="Alicante">Alicante</option><option value="Almería">Almería</option><option value="Asturias">Asturias</option><option value="Ávila">Ávila</option><option value="Badajoz">Badajoz</option><option value="Barcelona">Barcelona</option><option value="Burgos">Burgos</option><option value="Cáceres">Cáceres</option><option value="Cádiz">Cádiz</option><option value="Cantabria">Cantabria</option><option value="Castellón">Castellón</option><option value="Ciudad Real">Ciudad Real</option><option value="Córdoba">Córdoba</option><option value="Cuenca">Cuenca</option><option value="Girona">Girona</option><option value="Granada">Granada</option><option value="Guadalajara">Guadalajara</option><option value="Guipúzcoa">Guipúzcoa</option><option value="Huelva">Huelva</option><option value="Huesca">Huesca</option><option value="Islas Baleares">Islas Baleares</option><option value="Jaén">Jaén</option><option value="La Coruña">La Coruña</option><option value="La Rioja">La Rioja</option><option value="Las Palmas">Las Palmas</option><option value="León">León</option><option value="Lérida">Lérida</option><option value="Lugo">Lugo</option><option value="Madrid">Madrid</option><option value="Málaga">Málaga</option><option value="Murcia">Murcia</option><option value="Navarra">Navarra</option><option value="Ourense">Ourense</option><option value="Palencia">Palencia</option><option value="Pontevedra">Pontevedra</option><option value="Salamanca">Salamanca</option><option value="Santa Cruz de Tenerife">Santa Cruz de Tenerife</option><option value="Segovia">Segovia</option><option value="Sevilla">Sevilla</option><option value="Soria">Soria</option><option value="Tarragona">Tarragona</option><option value="Teruel">Teruel</option><option value="Toledo">Toledo</option><option value="Valencia">Valencia</option><option value="Valladolid">Valladolid</option><option value="Vizcaya">Vizcaya</option><option value="Zamora">Zamora</option><option value="Zaragoza">Zaragoza</option>
                                            </select>
                                        </div>
                                        <div class="form-group border-labeled">
                                            <label for="paisTutor" class="form-label-overlay">País del tutor *</label>
                                            <input type="text" id="paisTutor" name="paisTutor" class="form-input" placeholder="País">
                                        </div>
                                    </div>
                                    <div class="legal-disclaimer">
                                        <ul>
                                            <li>Este anexo es obligatorio al declarar una edad menor de 18 años.</li>
                                            <li>Deberá ser firmado y autorizado digitalmente o físicamente tras validarse.</li>
                                        </ul>
                                    </div>
                                </div>

                                <!-- TAB 2: Datos de Contacto -->
                                <div class="tab-pane" id="pane-2">
                                    <h4 class="section-title"><i class="fas fa-envelope-open-text"></i> Información de Contacto</h4>
                                    <p class="subtitle-desc">Dirección postal y datos de localización para el envío de notificaciones.</p>
                                    
                                    <div class="form-grid">
                                        <div class="form-group border-labeled">
                                            <label for="email" class="form-label-overlay">Email de contacto *</label>
                                            <input type="email" id="email" name="email" class="form-input" required placeholder="Correo electrónico">
                                        </div>
                                        <div class="form-group border-labeled">
                                            <label for="telefono" class="form-label-overlay">Teléfono *</label>
                                            <input type="tel" id="telefono" name="telefono" class="form-input" required placeholder="Teléfono">
                                        </div>
                                        <div class="form-group border-labeled" style="grid-column: span 2;">
                                            <label for="direccion" class="form-label-overlay">Dirección Postal *</label>
                                            <input type="text" id="direccion" name="direccion" class="form-input" required placeholder="Dirección">
                                        </div>
                                        <div class="form-group border-labeled">
                                            <label for="localidad" class="form-label-overlay">Localidad / Municipio *</label>
                                            <input type="text" id="localidad" name="localidad" class="form-input" required placeholder="Bilbao">
                                        </div>
                                        <div class="form-group border-labeled">
                                            <label for="provincia" class="form-label-overlay">Provincia *</label>
                                            <select id="provincia" name="provincia" class="form-select" required>
                                                <option value="">Selecciona...</option>
                                                <option value="Álava">Álava</option><option value="Albacete">Albacete</option><option value="Alicante">Alicante</option><option value="Almería">Almería</option><option value="Asturias">Asturias</option><option value="Ávila">Ávila</option><option value="Badajoz">Badajoz</option><option value="Barcelona">Barcelona</option><option value="Burgos">Burgos</option><option value="Cáceres">Cáceres</option><option value="Cádiz">Cádiz</option><option value="Cantabria">Cantabria</option><option value="Castellón">Castellón</option><option value="Ciudad Real">Ciudad Real</option><option value="Córdoba">Córdoba</option><option value="Cuenca">Cuenca</option><option value="Girona">Girona</option><option value="Granada">Granada</option><option value="Guadalajara">Guadalajara</option><option value="Guipúzcoa">Guipúzcoa</option><option value="Huelva">Huelva</option><option value="Huesca">Huesca</option><option value="Islas Baleares">Islas Baleares</option><option value="Jaén">Jaén</option><option value="La Coruña">La Coruña</option><option value="La Rioja">La Rioja</option><option value="Las Palmas">Las Palmas</option><option value="León">León</option><option value="Lérida">Lérida</option><option value="Lugo">Lugo</option><option value="Madrid">Madrid</option><option value="Málaga">Málaga</option><option value="Murcia">Murcia</option><option value="Navarra">Navarra</option><option value="Ourense">Ourense</option><option value="Palencia">Palencia</option><option value="Pontevedra">Pontevedra</option><option value="Salamanca">Salamanca</option><option value="Santa Cruz de Tenerife">Santa Cruz de Tenerife</option><option value="Segovia">Segovia</option><option value="Sevilla">Sevilla</option><option value="Soria">Soria</option><option value="Tarragona">Tarragona</option><option value="Teruel">Teruel</option><option value="Toledo">Toledo</option><option value="Valencia">Valencia</option><option value="Valladolid">Valladolid</option><option value="Vizcaya">Vizcaya</option><option value="Zamora">Zamora</option><option value="Zaragoza">Zaragoza</option>
                                            </select>
                                        </div>
                                        <div class="form-group border-labeled">
                                            <label for="codigo_postal" class="form-label-overlay">Código Postal *</label>
                                            <input type="text" id="codigo_postal" name="codigo_postal" class="form-input" required placeholder="48001">
                                        </div>
                                        <div class="form-group border-labeled">
                                            <label for="pais" class="form-label-overlay">País *</label>
                                            <input type="text" id="pais" name="pais" class="form-input" required placeholder="España">
                                        </div>
                                    </div>
                                </div>

                                <!-- TAB 3: Háblanos de ti -->
                                <div class="tab-pane" id="pane-3">
                                    <div class="split-layout">
                                        <div class="split-col">
                                            <h4 class="section-title"><i class="far fa-comments"></i> Presentación</h4>
                                            <p class="description-small">Escribe tu motivación para matricularte en ${Utils.sanitizeHTML(SchoolService.shortName())} o bien adjunta tu carta de presentación oficial.</p>
                                            <div class="form-group border-labeled">
                                                <label for="presentacionTexto" class="form-label-overlay">Carta de Presentación</label>
                                                <textarea id="presentacionTexto" name="presentacionTexto" class="form-textarea" rows="5" maxlength="5000" placeholder="Escribe aquí tu motivación e intereses..."></textarea>
                                            </div>
                                            <div class="form-group" style="margin-top: 0.65rem;">
                                                 <span class="form-label-overlay-static">O sube un archivo (Word o PDF)</span>
                                                 <div class="upload-zone" id="zone-hablanos_documento">
                                                     <input type="file" id="hablanos_documento" accept=".doc,.docx,application/pdf" class="visually-hidden">
                                                     <label for="hablanos_documento" class="upload-zone-label">
                                                         <i class="fas fa-file-word upload-icon"></i>
                                                         <span class="upload-text">Seleccionar Carta</span>
                                                         <span class="upload-hint">PDF, DOC, DOCX (Máx. 20MB)</span>
                                                     </label>
                                                     <div id="presentacion_preview_link" class="file-preview-status"></div>
                                                 </div>
                                            </div>
                                        </div>

                                        <div class="split-col">
                                            <h4 class="section-title"><i class="fas fa-graduation-cap"></i> Estudios</h4>
                                            <p class="description-small">Describe tu nivel de estudios académicos actuales o adjunta tu titulación o expediente acreditativo correspondiente.</p>
                                            <div class="form-group border-labeled">
                                                <label for="estudiosTexto" class="form-label-overlay">Estudios Académicos</label>
                                                <textarea id="estudiosTexto" name="estudiosTexto" class="form-textarea" rows="5" maxlength="5000" placeholder="Ej: Bachillerato, Formación Profesional, Grado Universitario..."></textarea>
                                            </div>
                                            <div class="form-group" style="margin-top: 0.65rem;">
                                                 <span class="form-label-overlay-static">O sube un archivo (Word o PDF)</span>
                                                 <div class="upload-zone" id="zone-estudiosArchivo">
                                                     <input type="file" id="estudiosArchivo" accept=".doc,.docx,application/pdf" class="visually-hidden">
                                                     <label for="estudiosArchivo" class="upload-zone-label">
                                                         <i class="fas fa-graduation-cap upload-icon"></i>
                                                         <span class="upload-text">Seleccionar Acreditación</span>
                                                         <span class="upload-hint">PDF, DOC, DOCX (Máx. 20MB)</span>
                                                     </label>
                                                     <div id="estudios_preview_link" class="file-preview-status"></div>
                                                 </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- TAB 4: Pago y Envío -->
                                <div class="tab-pane" id="pane-4">
                                    <h4 class="section-title"><i class="fas fa-check-circle"></i> Confirmación</h4>
                                    <p class="subtitle-desc">Por favor, revisa las instrucciones antes de finalizar tu solicitud de matrícula.</p>

                                    <div class="payment-instructions">
                                        <h5><i class="fas fa-info-circle"></i> Instrucciones de Matriculación</h5>
                                        <p>Una vez completado y enviado este formulario, la secretaría de ${Utils.sanitizeHTML(SchoolService.shortName())} revisará tus datos e información adjunta.</p>
                                        <p>Posteriormente, recibirás un correo electrónico de confirmación indicando el estado de tu admisión, junto con los pasos y métodos necesarios para realizar el abono de la matrícula.</p>
                                    </div>

                                    <div class="confirmation-checkboxes">
                                        <div class="form-checkbox-group">
                                            <input type="checkbox" id="privacidadCheck" class="form-checkbox">
                                            <label for="privacidadCheck">He leído y acepto la <a href="#" ${UIEvents.attr("click", function(event,captured){event.preventDefault();InscripcionView.showPrivacidadModal();}, [])}>política de privacidad</a> para tramitar mi matrícula en la escuela.</label>
                                        </div>
                                        <div class="form-checkbox-group">
                                            <input type="checkbox" id="normasCheck" class="form-checkbox">
                                            <label for="normasCheck">He leído y acepto la <a href="#" ${UIEvents.attr("click", function(event,captured){event.preventDefault();InscripcionView.showNormativaModal();}, [])}>normativa oficial</a> de ${Utils.sanitizeHTML(SchoolService.name())}.</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- CONTROL DE PASOS INFERIOR -->
                            <div class="form-steps-nav">
                                <button type="button" id="prevBtn" class="btn btn-prev" style="visibility: hidden;"><i class="fas fa-arrow-left"></i> Anterior</button>
                                <span class="step-indicator" id="stepIndicator" aria-live="polite">Paso 1 de 4</span>
                                <button type="button" id="nextBtn" class="btn btn-next">Siguiente paso <i class="fas fa-arrow-right"></i></button>
                                <button type="button" id="completarBtn" class="btn btn-submit" style="display: none;" disabled>
                                    <i class="fas fa-paper-plane"></i> Finalizar y Enviar
                                </button>
                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </div>

        <!-- CSS Premiums Autoinyectados (Tema Claro y Limpio - dnr-proposal) -->
        <style ${SafeHTML.styleAttr}>
            .public-enrollment-mode {
                --bg-canvas: #f8fafc;
                --card-bg: #ffffff;
                --text-primary: var(--dnr-ink, #0f172a);
                --text-secondary: var(--dnr-ink-mute, #475569);
                --text-muted: var(--dnr-ink-faint, #64748b);
                --accent-blue: var(--dnr-teal-600, #14867A);
                --accent-teal: var(--dnr-teal-600, #14867A);
                --accent-teal-dark: var(--dnr-teal-700, #0E6B62);
                --accent-teal-light: var(--dnr-teal-100, #DCF3EF);
                --border-color: var(--dnr-line, #E5E7EB);
                
                background: var(--bg-canvas);
                font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
                margin: 0;
                padding: 0;
                min-height: 100vh;
                position: relative;
            }
            .public-enrollment-container {
                display: block;
                min-height: 100vh;
                padding: 0;
                box-sizing: border-box;
                position: relative;
                z-index: 10;
            }

            /* Tarjeta Principal */
            .enrollment-card-main {
                background: var(--card-bg);
                border-radius: 0;
                box-shadow: none;
                width: 100vw;
                height: 100vh;
                box-sizing: border-box;
                overflow: hidden;
            }
            .enrollment-form-grid {
                display: grid;
                grid-template-columns: 280px 1fr;
                height: 100vh;
                margin: 0;
            }

            /* Sidebar: compacto, limpio y corporativo */
            .enrollment-card-sidebar {
                background: var(--dnr-surface-sunken, #f8fafc);
                border-right: 1px solid var(--dnr-line, #e2e8f0);
                padding: 1.5rem 1.25rem;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                box-sizing: border-box;
                height: 100vh;
                overflow-y: auto;
                flex-shrink: 0;
            }
            .sidebar-brand {
                display: flex;
                align-items: center;
                gap: 10px;
                margin-bottom: 1.25rem;
                padding-bottom: 0.9rem;
                border-bottom: 1px solid var(--dnr-line, #e2e8f0);
            }
            .logo-box {
                background: linear-gradient(135deg, var(--dnr-teal-900, #08312D) 0%, var(--dnr-teal-700, #0E6B62) 100%);
                width: 38px;
                height: 38px;
                border-radius: 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 4px;
                box-shadow: 0 2px 4px rgba(0,0,0,0.08);
            }
            .sidebar-logo {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
            .brand-details {
                display: flex;
                flex-direction: column;
            }
            .brand-main {
                font-family: var(--dnr-display, 'Outfit', sans-serif);
                font-weight: 800;
                font-size: 1.15rem;
                color: var(--dnr-ink, #0f172a);
                line-height: 1.1;
                letter-spacing: 0.02em;
            }
            .brand-sub {
                font-family: var(--dnr-mono, monospace);
                font-size: 0.65rem;
                font-weight: 700;
                color: var(--dnr-teal-700, #0E6B62);
                text-transform: uppercase;
                letter-spacing: 0.08em;
            }

            /* Stepper Vertical */
            .enrollment-stepper {
                list-style: none;
                padding: 0;
                margin: 0;
                display: flex;
                flex-direction: column;
                gap: 0.75rem;
                position: relative;
            }
            .enrollment-stepper::before {
                content: '';
                position: absolute;
                left: 15px;
                top: 10px;
                bottom: 15px;
                width: 2px;
                background: var(--dnr-line, #e2e8f0);
                z-index: 1;
            }
            .tab-item {
                display: flex;
                align-items: center;
                gap: 11px;
                cursor: pointer;
                position: relative;
                z-index: 2;
                user-select: none;
                padding: 3px 6px;
                border-radius: 6px;
                transition: background-color 0.15s ease;
            }
            .tab-item:hover {
                background: rgba(20, 134, 122, 0.05);
            }
            .step-icon-circle {
                width: 32px;
                height: 32px;
                border-radius: 50%;
                background: #ffffff;
                border: 1.5px solid var(--dnr-line, #cbd5e1);
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.8rem;
                font-weight: 700;
                color: var(--dnr-ink-faint, #94a3b8);
                transition: all 0.2s ease;
                position: relative;
                z-index: 3;
                font-family: var(--dnr-mono, monospace);
                flex-shrink: 0;
            }
            .step-check-icon {
                display: none;
                font-size: 0.8rem;
            }
            .tab-label {
                font-size: 0.84rem;
                font-weight: 600;
                color: var(--dnr-ink-mute, #475569);
                transition: color 0.2s ease;
                font-family: var(--dnr-display, 'Outfit', sans-serif);
            }
            .tab-item.active .step-icon-circle {
                border-color: var(--dnr-teal-600, #14867A);
                background: var(--dnr-teal-100, #DCF3EF);
                color: var(--dnr-teal-700, #0E6B62);
                box-shadow: 0 0 0 3px var(--dnr-teal-100, #DCF3EF);
            }
            .tab-item.active .tab-label {
                color: var(--dnr-teal-700, #0E6B62);
                font-weight: 700;
            }
            .tab-item.completed .step-icon-circle {
                background: var(--dnr-teal-700, #0E6B62);
                border-color: var(--dnr-teal-700, #0E6B62);
                color: #ffffff;
            }
            .tab-item.active.completed .step-icon-circle {
                border-color: var(--dnr-teal-600, #14867A);
                box-shadow: 0 0 0 3px var(--dnr-teal-100, #DCF3EF);
            }
            .tab-item.completed .step-number {
                display: none;
            }
            .tab-item.completed .step-check-icon {
                display: block;
            }
            .tab-item.completed .tab-label {
                color: var(--dnr-ink-mute, #475569);
            }

            .enrollment-draft-tools {
                margin-top: 1rem;
                display: flex;
                flex-direction: column;
                gap: 0.5rem;
                padding-top: 0.85rem;
                border-top: 1px solid var(--dnr-line, #e2e8f0);
            }
            .btn-save-draft {
                background: #ffffff;
                border: 1px solid var(--dnr-line, #cbd5e1);
                color: var(--dnr-ink-mute, #475569);
                width: 100%;
                padding: 0.5rem 0.85rem;
                font-size: 0.82rem;
                border-radius: 6px;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 6px;
                font-weight: 700;
                transition: all 0.15s ease;
                cursor: pointer;
                font-family: var(--dnr-display, 'Outfit', sans-serif);
            }
            .btn-save-draft:hover {
                border-color: var(--dnr-teal-500, #1CA093);
                color: var(--dnr-teal-700, #0E6B62);
                background: var(--dnr-teal-100, #DCF3EF);
            }
            .token-badge-sidebar {
                font-size: 0.72rem;
                color: var(--dnr-teal-900, #08312D);
                text-align: center;
                background: var(--dnr-teal-100, #DCF3EF);
                padding: 6px 8px;
                border-radius: 6px;
                border: 1px solid var(--dnr-teal-500, #1CA093);
                word-break: break-all;
                line-height: 1.35;
                font-family: var(--dnr-mono, monospace);
            }
            .load-draft-container {
                margin-top: 0.25rem;
                display: flex;
                flex-direction: column;
                gap: 0.3rem;
            }
            .load-draft-title {
                font-size: 0.68rem;
                font-weight: 700;
                color: var(--dnr-ink-faint, #64748b);
                font-family: var(--dnr-mono, monospace);
                text-transform: uppercase;
                letter-spacing: 0.04em;
                margin-left: 2px;
            }
            .load-draft-input-group {
                display: flex;
                gap: 0.3rem;
            }
            .load-draft-input {
                flex: 1;
                border: 1px solid var(--dnr-line, #cbd5e1);
                border-radius: 6px;
                padding: 0.4rem 0.6rem;
                font-size: 0.78rem;
                outline: none;
                transition: all 0.15s ease;
                background: #ffffff;
                color: var(--dnr-ink, #0f172a);
            }
            .load-draft-input:focus {
                border-color: var(--dnr-teal-500, #1CA093);
                box-shadow: 0 0 0 2px var(--dnr-teal-100, #DCF3EF);
            }
            .btn-load-draft {
                background: var(--dnr-teal-600, #14867A);
                border: none;
                color: #ffffff;
                border-radius: 6px;
                width: 30px;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                transition: all 0.15s ease;
                font-size: 0.8rem;
            }
            .btn-load-draft:hover {
                background: var(--dnr-teal-700, #0E6B62);
            }

            /* Content Area: espaciado compacto y armónico */
            .enrollment-card-content {
                padding: 1.35rem 2rem;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                position: relative;
                height: 100vh;
                overflow-y: auto;
                background: var(--card-bg);
            }
            .support-link {
                position: absolute;
                top: 1.25rem;
                right: 2rem;
                font-size: 0.78rem;
                color: var(--dnr-ink-faint, #64748b);
            }
            .support-link a {
                color: var(--dnr-teal-600, #14867A);
                text-decoration: none;
                font-weight: 700;
            }
            .support-link a:hover {
                text-decoration: underline;
            }

            .tab-pane {
                display: none;
            }
            .tab-pane.active {
                display: block;
                animation: fadeIn 0.3s ease;
            }
            .section-title {
                font-family: var(--dnr-display, 'Outfit', sans-serif);
                font-size: 1.15rem;
                font-weight: 700;
                color: var(--dnr-ink, #0f172a);
                margin-top: 0;
                margin-bottom: 0.15rem;
                display: flex;
                align-items: center;
                gap: 8px;
                letter-spacing: -0.01em;
            }
            .section-title i {
                color: var(--dnr-teal-600, #14867A);
                font-size: 1.05rem;
            }
            .section-title-inside {
                font-family: var(--dnr-display, 'Outfit', sans-serif);
                font-size: 0.92rem;
                font-weight: 700;
                color: var(--dnr-teal-700, #0E6B62);
                margin-top: 0;
                margin-bottom: 0.6rem;
                display: flex;
                align-items: center;
                gap: 6px;
            }
            .subtitle-desc {
                font-size: 0.8rem;
                color: var(--dnr-ink-mute, #475569);
                margin-top: 0;
                margin-bottom: 0.65rem;
            }

            /* Form Group with Cutout Outline Label */
            .form-group.border-labeled {
                position: relative;
                margin-bottom: 0.65rem;
                display: flex;
                flex-direction: column;
            }
            .form-group.border-labeled .form-input,
            .form-group.border-labeled .form-select,
            .form-group.border-labeled .form-textarea {
                border: 1px solid var(--dnr-line, #cbd5e1);
                border-radius: 6px;
                padding: 0.48rem 0.75rem;
                font-size: 0.88rem;
                background: #ffffff;
                color: var(--dnr-ink, #0f172a);
                width: 100%;
                box-sizing: border-box;
                outline: none;
                transition: border-color 0.15s ease, box-shadow 0.15s ease;
                font-family: inherit;
            }
            .form-group.border-labeled .form-input:focus,
            .form-group.border-labeled .form-select:focus,
            .form-group.border-labeled .form-textarea:focus {
                border-color: var(--dnr-teal-500, #1CA093);
                box-shadow: 0 0 0 3px var(--dnr-teal-100, #DCF3EF);
            }
            .form-group.border-labeled .form-label-overlay {
                position: absolute;
                top: -7px;
                left: 10px;
                font-size: 0.65rem;
                font-weight: 700;
                color: var(--dnr-ink-faint, #64748b);
                background: #ffffff;
                padding: 0 5px;
                z-index: 10;
                transition: color 0.15s ease;
                pointer-events: none;
                font-family: var(--dnr-mono, monospace);
                text-transform: uppercase;
                letter-spacing: 0.04em;
            }
            .form-group.border-labeled:focus-within .form-label-overlay {
                color: var(--dnr-teal-700, #0E6B62);
            }

            /* Invalid field highlight */
            .form-input.is-invalid,
            .form-select.is-invalid,
            .form-textarea.is-invalid {
                border-color: #ef4444 !important;
                box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1) !important;
            }
            .upload-zone.is-invalid .upload-zone-label {
                border-color: #ef4444 !important;
                background-color: rgba(239, 68, 68, 0.02) !important;
            }
            .form-group:has(.is-invalid) .form-label-overlay-static,
            .form-group.border-labeled:has(.is-invalid) .form-label-overlay {
                color: #ef4444 !important;
            }
            .form-checkbox.is-invalid {
                border-color: #ef4444 !important;
                box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1) !important;
            }
            .dnd-list-box.is-invalid {
                border: 2px dashed #ef4444 !important;
                border-radius: 6px;
                padding: 0.5rem;
                background: rgba(239, 68, 68, 0.02);
            }

            /* Select customization */
            .form-group.border-labeled select.form-select {
                appearance: none;
                -webkit-appearance: none;
                background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%2364748b' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7'/%3E%3C/svg%3E");
                background-repeat: no-repeat;
                background-position: right 0.75rem center;
                background-size: 0.85rem;
                padding-right: 2rem;
                cursor: pointer;
            }
            .form-group.border-labeled select.form-select:disabled {
                opacity: 0.6;
                cursor: not-allowed;
                background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%23cbd5e1' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7'/%3E%3C/svg%3E");
            }

            .form-grid {
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 0.6rem 0.85rem;
            }

            /* Selector Box */
            .formation-selector-box {
                border: 1px solid var(--dnr-line, #cbd5e1);
                border-radius: 8px;
                padding: 0.75rem 1rem;
                background: var(--dnr-surface-sunken, #f8fafc);
                margin-bottom: 0.75rem;
            }
            .form-label-overlay-static {
                font-size: 0.68rem;
                font-weight: 700;
                color: var(--dnr-ink-faint, #64748b);
                margin-bottom: 0.3rem;
                display: inline-block;
                font-family: var(--dnr-mono, monospace);
                text-transform: uppercase;
                letter-spacing: 0.04em;
            }

            /* DnD list */
            .dnd-list-box {
                display: flex;
                flex-direction: column;
                gap: 0.45rem;
            }
            .dnd-item {
                background: #ffffff;
                border: 1px solid var(--dnr-line, #e2e8f0);
                border-left: 4px solid var(--dnr-teal-600, #14867A);
                border-radius: 6px;
                padding: 0.5rem 0.75rem;
                font-size: 0.85rem;
                display: flex;
                align-items: center;
                gap: 8px;
                cursor: grab;
                transition: all 0.15s ease;
                user-select: none;
            }
            .dnd-item:hover {
                border-color: var(--dnr-teal-500, #1CA093);
                box-shadow: 0 2px 4px rgba(0,0,0,0.04);
                transform: translateY(-1px);
            }
            .dnd-item:active {
                cursor: grabbing;
            }
            .orden-num {
                font-weight: 800;
                color: var(--dnr-teal-700, #0E6B62);
                min-width: 18px;
                font-family: var(--dnr-mono, monospace);
            }
            .draggable-grip {
                color: var(--dnr-ink-faint, #94a3b8);
                font-size: 0.8rem;
            }

            /* Webcam Section */
            .photo-capture-section {
                display: grid;
                grid-template-columns: 130px 1fr;
                gap: 1.15rem;
                background: var(--dnr-surface-sunken, #f8fafc);
                padding: 0.75rem 1rem;
                border-radius: 8px;
                border: 1px solid var(--dnr-line, #cbd5e1);
                align-items: center;
            }
            .photo-preview-box {
                width: 130px;
                height: 130px;
                background: #ffffff;
                border-radius: 8px;
                overflow: hidden;
                position: relative;
                border: 1.5px solid var(--dnr-line, #cbd5e1);
            }
            .placeholder-overlay {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                height: 100%;
                color: var(--dnr-ink-faint, #94a3b8);
                gap: 0.35rem;
                font-size: 0.78rem;
            }
            .placeholder-overlay i {
                font-size: 2.2rem;
            }
            .viewfinder-overlay {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 3;
                pointer-events: none;
            }
            .viewfinder-corner {
                position: absolute;
                width: 10px;
                height: 10px;
                border: 2px solid var(--dnr-teal-500, #1CA093);
            }
            .viewfinder-corner.top-left {
                top: 8px;
                left: 8px;
                border-right: none;
                border-bottom: none;
            }
            .viewfinder-corner.top-right {
                top: 8px;
                right: 8px;
                border-left: none;
                border-bottom: none;
            }
            .viewfinder-corner.bottom-left {
                bottom: 8px;
                left: 8px;
                border-right: none;
                border-top: none;
            }
            .viewfinder-corner.bottom-right {
                bottom: 8px;
                right: 8px;
                border-left: none;
                border-top: none;
            }
            .viewfinder-grid {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                opacity: 0.08;
            }
            .grid-line.horizontal {
                position: absolute;
                top: 50%;
                left: 0;
                width: 100%;
                height: 1px;
                background: #000;
                transform: translateY(-50%);
            }
            .grid-line.vertical {
                position: absolute;
                left: 50%;
                top: 0;
                width: 1px;
                height: 100%;
                background: #000;
                transform: translateX(-50%);
            }
            .rec-indicator {
                position: absolute;
                top: 8px;
                right: 8px;
                background: rgba(255, 255, 255, 0.9);
                padding: 2px 5px;
                border-radius: 4px;
                font-size: 0.6rem;
                font-weight: 700;
                color: #ef4444;
                display: flex;
                align-items: center;
                gap: 4px;
                letter-spacing: 0.5px;
                border: 1px solid rgba(239, 68, 68, 0.2);
            }
            .pulse-dot {
                width: 5px;
                height: 5px;
                background: #ef4444;
                border-radius: 50%;
                animation: pulse 1s infinite alternate;
            }
            .photo-controls {
                display: flex;
                flex-direction: column;
                justify-content: center;
                gap: 0.55rem;
            }
            .photo-upload-zone .upload-zone-label {
                padding: 0.65rem 0.85rem;
            }
            .camera-actions {
                display: flex;
                gap: 0.65rem;
            }
            .btn-activate-camera {
                background: #ffffff;
                border: 1.5px solid var(--dnr-teal-600, #14867A);
                color: var(--dnr-teal-700, #0E6B62);
                padding: 0.42rem 0.85rem;
                font-size: 0.8rem;
                border-radius: 6px;
            }
            .btn-activate-camera:hover {
                background: var(--dnr-teal-100, #DCF3EF);
            }
            .btn-shutter {
                background: #ef4444;
                color: #ffffff;
                box-shadow: 0 2px 6px rgba(239, 68, 68, 0.2);
                padding: 0.42rem 0.85rem;
                font-size: 0.8rem;
                border-radius: 6px;
            }
            .btn-shutter:hover {
                background: #dc2626;
            }

            /* Visually Hidden native input */
            .visually-hidden {
                position: absolute;
                width: 1px;
                height: 1px;
                padding: 0;
                margin: -1px;
                overflow: hidden;
                clip: rect(0, 0, 0, 0);
                white-space: nowrap;
                border: 0;
            }

            /* Upload zone cards */
            .upload-zone {
                position: relative;
                width: 100%;
            }
            .upload-zone-label {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding: 0.75rem 1rem;
                background: #ffffff;
                border: 1.5px dashed var(--dnr-line, #cbd5e1);
                border-radius: 6px;
                cursor: pointer;
                transition: all 0.2s ease;
                text-align: center;
            }
            .upload-zone-label:hover {
                background: var(--dnr-teal-100, #DCF3EF);
                border-color: var(--dnr-teal-500, #1CA093);
            }
            .upload-icon {
                font-size: 1.25rem;
                color: var(--dnr-teal-600, #14867A);
                margin-bottom: 0.25rem;
                transition: transform 0.2s ease;
            }
            .upload-zone-label:hover .upload-icon {
                transform: translateY(-2px);
            }
            .upload-text {
                font-size: 0.8rem;
                font-weight: 700;
                color: var(--dnr-ink-mute, #475569);
                margin-bottom: 0.1rem;
            }
            .upload-hint {
                font-size: 0.68rem;
                color: var(--dnr-ink-faint, #64748b);
            }
            .file-preview-status {
                margin-top: 0.35rem;
                font-size: 0.8rem;
                display: flex;
                align-items: center;
                gap: 0.4rem;
                color: #10b981;
            }
            .file-preview-status a {
                color: var(--dnr-teal-600, #14867A);
                text-decoration: none;
                font-weight: 700;
            }
            .file-preview-status a:hover {
                text-decoration: underline;
            }

            .legal-disclaimer {
                background: rgba(245, 158, 11, 0.06);
                border: 1px solid rgba(245, 158, 11, 0.2);
                border-radius: 6px;
                padding: 0.65rem 0.85rem;
                margin-top: 0.75rem;
            }
            .legal-disclaimer ul {
                margin: 0;
                padding-left: 1.15rem;
                font-size: 0.78rem;
                color: #b45309;
                line-height: 1.4;
            }

            .split-layout {
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 1.15rem;
            }
            .description-small {
                font-size: 0.8rem;
                color: var(--dnr-ink-mute, #475569);
                margin-top: -0.15rem;
                margin-bottom: 0.6rem;
                line-height: 1.4;
            }

            /* Pago y Checkboxes */
            .payment-instructions {
                background: var(--dnr-surface-sunken, #f8fafc);
                border: 1px solid var(--dnr-line, #cbd5e1);
                border-radius: 8px;
                padding: 0.85rem 1.15rem;
                margin-bottom: 0.75rem;
            }
            .payment-instructions h5 {
                font-size: 0.92rem;
                font-weight: 700;
                color: var(--dnr-teal-700, #0E6B62);
                margin-top: 0;
                margin-bottom: 0.35rem;
                display: flex;
                align-items: center;
                gap: 6px;
                font-family: var(--dnr-display, 'Outfit', sans-serif);
            }
            .payment-instructions p {
                font-size: 0.82rem;
                color: var(--dnr-ink-mute, #475569);
                line-height: 1.45;
                margin: 0.35rem 0;
            }
            .form-checkbox-group {
                display: flex;
                align-items: flex-start;
                gap: 0.6rem;
                margin-bottom: 0.55rem;
            }
            .form-checkbox {
                appearance: none;
                -webkit-appearance: none;
                width: 1.05rem;
                height: 1.05rem;
                border: 1.5px solid var(--dnr-line, #cbd5e1);
                border-radius: 4px;
                background: #ffffff;
                cursor: pointer;
                position: relative;
                outline: none;
                transition: all 0.15s ease;
                flex-shrink: 0;
                margin-top: 2px;
            }
            .form-checkbox:checked {
                background: var(--dnr-teal-600, #14867A);
                border-color: var(--dnr-teal-600, #14867A);
            }
            .form-checkbox:checked::after {
                content: '\\f00c';
                font-family: 'Font Awesome 6 Free';
                font-weight: 900;
                font-size: 0.7rem;
                color: #ffffff;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
            .form-checkbox-group label {
                font-size: 0.82rem;
                color: var(--dnr-ink-mute, #475569);
                line-height: 1.4;
                cursor: pointer;
            }
            .form-checkbox-group label a {
                color: var(--dnr-teal-600, #14867A);
                text-decoration: none;
                font-weight: 700;
            }
            .form-checkbox-group label a:hover {
                text-decoration: underline;
            }

            /* Step Navigation */
            .form-steps-nav {
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-top: 1px solid var(--dnr-line, #e2e8f0);
                padding-top: 0.75rem;
                margin-top: 0.75rem;
            }
            .step-indicator {
                font-size: 0.78rem;
                font-weight: 700;
                color: var(--dnr-ink-faint, #64748b);
                font-family: var(--dnr-mono, monospace);
                text-transform: uppercase;
                letter-spacing: 0.05em;
            }
            .btn {
                font-family: var(--dnr-display, 'Outfit', sans-serif);
                font-weight: 700;
                border-radius: 6px;
                cursor: pointer;
                font-size: 0.88rem;
                transition: all 0.15s ease;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                padding: 0.5rem 1.25rem;
                border: none;
            }
            .btn-prev {
                background: #ffffff;
                border: 1px solid var(--dnr-line, #cbd5e1);
                color: var(--dnr-ink-mute, #475569);
            }
            .btn-prev:hover {
                background: var(--dnr-surface-sunken, #f8fafc);
                border-color: var(--dnr-ink-faint, #94a3b8);
                color: var(--dnr-ink, #0f172a);
            }
            .btn-next {
                background: var(--dnr-teal-600, #14867A);
                color: #ffffff;
                box-shadow: 0 2px 6px rgba(20, 134, 122, 0.25);
            }
            .btn-next:hover {
                background: var(--dnr-teal-700, #0E6B62);
                box-shadow: 0 3px 8px rgba(20, 134, 122, 0.35);
            }
            .btn-submit {
                background: #10b981;
                color: #ffffff;
                box-shadow: 0 2px 6px rgba(16, 185, 129, 0.25);
            }
            .btn-submit:hover {
                background: #059669;
                box-shadow: 0 3px 8px rgba(16, 185, 129, 0.35);
            }
            .btn-submit:disabled {
                background: #e2e8f0;
                color: #94a3b8;
                box-shadow: none;
                cursor: not-allowed;
            }

            /* Responsive */
            @media (max-width: 850px) {
                .enrollment-card-main {
                    height: auto;
                    overflow: visible;
                }
                .enrollment-form-grid {
                    grid-template-columns: 1fr;
                    height: auto;
                }
                .enrollment-card-sidebar {
                    border-right: none;
                    border-bottom: 1px solid var(--dnr-line, #e2e8f0);
                    padding: 1.25rem;
                    height: auto;
                    overflow-y: visible;
                }
                .enrollment-card-content {
                    height: auto;
                    overflow-y: visible;
                    padding: 1.25rem;
                }
                .enrollment-stepper {
                    flex-direction: row;
                    justify-content: space-between;
                    gap: 0.5rem;
                }
                .enrollment-stepper::before {
                    display: none;
                }
                .tab-label {
                    display: none;
                }
                .sidebar-brand {
                    margin-bottom: 0.85rem;
                }
                .enrollment-draft-tools {
                    display: none;
                }
            }
            @media (max-width: 640px) {
                .form-grid {
                    grid-template-columns: 1fr;
                }
                .split-layout {
                    grid-template-columns: 1fr;
                }
                .photo-capture-section {
                    grid-template-columns: 1fr;
                    justify-items: center;
                }
                .support-link {
                    position: static;
                    margin-bottom: 1rem;
                    text-align: right;
                }
                .enrollment-card-content {
                    padding: 1.25rem 1rem;
                }
            }

            /* ===== Rediseño 2026-10 (capa final: marca SICAF, más legible y compacto) ===== */
            .public-enrollment-mode .ins-camera-btn {
                margin-top: 0.5rem; width: 100%; min-height: 44px; border-radius: 10px; border: 0; cursor: pointer;
                background: #0E6B62; color: #fff; font: inherit; font-weight: 600; font-size: 0.92rem;
                display: inline-flex; align-items: center; justify-content: center; gap: 0.5rem;
            }
            .public-enrollment-mode .ins-camera-btn[hidden] { display: none; }
            /* Cámara del DNI a pantalla completa (fuera de .public-enrollment-mode: cuelga del body). */
            .idcam-overlay { position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; height: 100dvh; z-index: 3000; background: #000; color: #fff; font-family: 'Inter', -apple-system, sans-serif; overflow: hidden; }
            .idcam-video { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; }
            .idcam-card { position: absolute; border: 3px solid #4FD8C4; border-radius: 14px; box-shadow: 0 0 0 200vmax rgba(0,0,0,0.55); pointer-events: none; }
            .idcam-top { position: absolute; top: 0; left: 0; right: 0; padding: max(14px, env(safe-area-inset-top)) 18px 14px; text-align: center; display: flex; flex-direction: column; gap: 4px; background: linear-gradient(180deg, rgba(0,0,0,0.6), rgba(0,0,0,0)); }
            .idcam-top strong { font-family: 'Bebas Neue', 'Arial Narrow', sans-serif; font-weight: 400; font-size: 1.7rem; letter-spacing: 0.03em; }
            .idcam-top span { font-size: 0.9rem; color: rgba(255,255,255,0.85); }
            .idcam-bottom { position: absolute; left: 0; right: 0; bottom: 0; padding: 16px 22px max(18px, env(safe-area-inset-bottom)); display: grid; grid-template-columns: 1fr auto 1fr; align-items: center; background: linear-gradient(0deg, rgba(0,0,0,0.65), rgba(0,0,0,0)); }
            .idcam-text-btn { justify-self: start; background: rgba(255,255,255,0.14); color: #fff; border: 1px solid rgba(255,255,255,0.3); border-radius: 999px; padding: 0.65rem 1.1rem; font: inherit; font-weight: 600; display: inline-flex; gap: 0.45rem; align-items: center; }
            .idcam-shutter { width: 74px; height: 74px; border-radius: 50%; border: 4px solid #fff; background: transparent; padding: 5px; }
            .idcam-shutter span { display: block; width: 100%; height: 100%; border-radius: 50%; background: #fff; }
            .idcam-shutter:disabled { opacity: 0.4; }
            .idcam-shutter:not(:disabled):active span { background: #4FD8C4; }
            .idcam-error { position: absolute; left: 18px; right: 18px; top: 45%; margin: 0; padding: 14px; border-radius: 12px; background: rgba(214,72,60,0.92); text-align: center; }
            .idcam-review { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; padding: 96px 16px 120px; }
            .idcam-photo { max-width: 100%; max-height: 100%; border-radius: 14px; border: 2px solid rgba(255,255,255,0.35); }
            .idcam-review-actions { grid-template-columns: 1fr 1fr; gap: 12px; }
            .idcam-review-actions .idcam-text-btn { justify-self: stretch; justify-content: center; }
            .idcam-use-btn { background: #4FD8C4; color: #08312D; border: 0; border-radius: 999px; padding: 0.7rem 1.1rem; font: inherit; font-weight: 700; display: inline-flex; gap: 0.45rem; align-items: center; justify-content: center; }
            /* Horizontal: texto a la izquierda y disparador a la derecha; el marco queda libre. */
            .idcam-overlay:fullscreen { width: 100%; height: 100%; }
            @media (orientation: landscape) {
                .idcam-overlay .idcam-top {
                    right: auto; bottom: 0; width: 22%; justify-content: center; text-align: left; gap: 8px;
                    padding: 16px 14px 16px max(16px, env(safe-area-inset-left));
                    background: linear-gradient(90deg, rgba(0,0,0,0.7), rgba(0,0,0,0));
                }
                .idcam-overlay .idcam-top strong { font-size: 1.5rem; line-height: 1.05; }
                .idcam-overlay .idcam-top span { font-size: 0.82rem; }
                .idcam-overlay .idcam-bottom {
                    left: auto; top: 0; width: 18%; display: flex; flex-direction: column; justify-content: center;
                    align-items: center; gap: 18px; padding: 16px max(14px, env(safe-area-inset-right)) 16px 10px;
                    background: linear-gradient(270deg, rgba(0,0,0,0.7), rgba(0,0,0,0));
                }
                .idcam-overlay .idcam-bottom .idcam-text-btn { order: 2; justify-self: auto; padding: 0.5rem 0.9rem; font-size: 0.85rem; }
                .idcam-overlay .idcam-bottom .idcam-shutter { order: 1; }
                .idcam-overlay .idcam-spacer { display: none; }
                .idcam-review { padding: 16px 20% 16px 22%; }
                .idcam-overlay .idcam-review-actions { display: flex; }
                .idcam-overlay .idcam-review-actions .idcam-text-btn { order: 2; }
                .idcam-overlay .idcam-review-actions .idcam-use-btn { order: 1; width: 100%; }
            }
            .public-enrollment-mode {
                --ins-teal-900: #08312D; --ins-teal-700: #0E6B62; --ins-teal-600: #14867A; --ins-teal-500: #1CA093;
                --ins-teal-400: #4FD8C4; --ins-teal-100: #DCF3EF; --ins-ink: #0F1B19; --ins-mute: #55665F;
                --ins-faint: #8A9993; --ins-line: #DBE3DF; --ins-sunken: #F3F6F4; --ins-danger: #D6483C;
                font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
                color: var(--ins-ink);
            }
            .public-enrollment-mode .enrollment-form-grid { grid-template-columns: 300px 1fr; }

            /* Lateral: la cabecera de marca */
            .public-enrollment-mode .enrollment-card-sidebar {
                background: linear-gradient(165deg, var(--ins-teal-900) 0%, var(--ins-teal-700) 100%);
                border-right: 0; color: #EAF7F4; padding: 1.75rem 1.4rem;
            }
            .public-enrollment-mode .sidebar-brand {
                padding-bottom: 1.25rem; margin-bottom: 1.5rem; border-bottom: 1px solid rgba(255,255,255,0.12);
            }
            .public-enrollment-mode .logo-box {
                background: rgba(255,255,255,0.08); border: 1px solid rgba(255,255,255,0.18); border-radius: 14px;
                width: 52px; height: 52px; padding: 7px; box-shadow: none;
            }
            .public-enrollment-mode .brand-main {
                font-family: 'Bebas Neue', 'Arial Narrow', sans-serif; font-weight: 400; font-size: 1.9rem;
                letter-spacing: 0.02em; color: #fff; line-height: 1;
            }
            .public-enrollment-mode .brand-sub {
                font-family: ui-monospace, 'SF Mono', Menlo, monospace; font-size: 0.66rem; letter-spacing: 0.12em;
                text-transform: uppercase; color: var(--ins-teal-400);
            }
            .public-enrollment-mode .enrollment-stepper::before { background: rgba(255,255,255,0.16); }
            .public-enrollment-mode .tab-item { border-radius: 12px; padding: 0.6rem 0.65rem; margin-bottom: 0.35rem; align-items: center; background: transparent; border: 0; }
            .public-enrollment-mode .tab-item:hover { background: rgba(255,255,255,0.06); }
            .public-enrollment-mode .tab-item.active { background: rgba(255,255,255,0.1); box-shadow: inset 3px 0 0 var(--ins-teal-400); }
            .public-enrollment-mode .step-icon-circle {
                background: transparent; border: 1.5px solid rgba(255,255,255,0.35); color: rgba(255,255,255,0.8);
                width: 32px; height: 32px; font-size: 0.82rem;
            }
            .public-enrollment-mode .tab-item.active .step-icon-circle { background: var(--ins-teal-400); border-color: var(--ins-teal-400); color: var(--ins-teal-900); box-shadow: 0 0 0 4px rgba(79,216,196,0.18); }
            .public-enrollment-mode .tab-item.completed .step-icon-circle { background: rgba(79,216,196,0.18); border-color: var(--ins-teal-400); color: var(--ins-teal-400); }
            .public-enrollment-mode .tab-text { display: flex; flex-direction: column; gap: 1px; min-width: 0; }
            .public-enrollment-mode .tab-label { color: rgba(255,255,255,0.78); font-weight: 600; font-size: 0.92rem; }
            .public-enrollment-mode .tab-item.active .tab-label { color: #fff; }
            .public-enrollment-mode .tab-item.completed .tab-label { color: rgba(255,255,255,0.9); }
            .public-enrollment-mode .tab-desc { font-size: 0.72rem; color: rgba(234,247,244,0.55); }
            .public-enrollment-mode .enrollment-draft-tools { border-top: 1px solid rgba(255,255,255,0.12); }
            .public-enrollment-mode .btn-save-draft {
                background: rgba(255,255,255,0.08); border: 1px solid rgba(255,255,255,0.22); color: #fff; border-radius: 10px;
            }
            .public-enrollment-mode .btn-save-draft:hover { background: rgba(255,255,255,0.16); border-color: rgba(255,255,255,0.35); }
            .public-enrollment-mode .load-draft-title { color: rgba(234,247,244,0.65); }
            .public-enrollment-mode .load-draft-input { background: rgba(255,255,255,0.08); border: 1px solid rgba(255,255,255,0.2); color: #fff; border-radius: 10px; }
            .public-enrollment-mode .load-draft-input::placeholder { color: rgba(234,247,244,0.45); }
            .public-enrollment-mode .btn-load-draft { background: var(--ins-teal-400); color: var(--ins-teal-900); border-radius: 10px; }
            .public-enrollment-mode .token-badge-sidebar { background: rgba(255,255,255,0.08); border-color: rgba(255,255,255,0.2); color: #EAF7F4; }

            /* Contenido: columna centrada, barra de progreso y navegación fija */
            .public-enrollment-mode .enrollment-card-content { padding: 0 2.5rem; background: #fff; }
            .public-enrollment-mode .ins-progress { position: sticky; top: 0; z-index: 20; height: 4px; flex-shrink: 0; margin: 0 -2.5rem; background: var(--ins-sunken); }
            .public-enrollment-mode .ins-progress span { display: block; height: 100%; width: 20%; background: linear-gradient(90deg, var(--ins-teal-500), var(--ins-teal-400)); border-radius: 0 999px 999px 0; transition: width 0.35s ease; }
            .public-enrollment-mode .support-link { position: static; text-align: right; padding: 0.9rem 0 0; font-size: 0.8rem; }
            .public-enrollment-mode .tab-content-wrapper { width: 100%; max-width: 1200px; margin: 0 auto; padding: 0.5rem 0 1.5rem; flex: 1 0 auto; display: flex; flex-direction: column; }
            /* Paso 3: los textos ocupan todo el alto disponible; las subidas quedan debajo. */
            .public-enrollment-mode #pane-3.active { display: flex; flex-direction: column; flex: 1 0 auto; }
            .public-enrollment-mode #pane-3 .split-layout { flex: 1 0 auto; gap: 2rem; }
            .public-enrollment-mode #pane-3 .split-col { display: flex; flex-direction: column; min-width: 0; }
            .public-enrollment-mode #pane-3 .split-col > .form-group.border-labeled { flex: 1 0 auto; }
            .public-enrollment-mode #pane-3 .form-group.border-labeled .form-textarea { flex: 1 0 auto; min-height: 220px; }
            .public-enrollment-mode #pane-3 .split-col > .form-group:not(.border-labeled) { margin: 0.25rem 0 0 !important; }
            .public-enrollment-mode .section-title {
                font-family: 'Bebas Neue', 'Arial Narrow', sans-serif; font-weight: 400; font-size: 1.85rem;
                letter-spacing: 0.02em; color: var(--ins-ink); margin: 1.25rem 0 0.15rem; gap: 0.6rem;
            }
            .public-enrollment-mode .section-title i {
                width: 34px; height: 34px; border-radius: 10px; display: inline-flex; align-items: center; justify-content: center;
                background: var(--ins-teal-100); color: var(--ins-teal-700); font-size: 0.95rem; flex-shrink: 0;
            }
            .public-enrollment-mode .tab-pane > .section-title:first-child,
            .public-enrollment-mode .split-col > .section-title:first-child { margin-top: 0.75rem; }
            .public-enrollment-mode .subtitle-desc,
            .public-enrollment-mode .description-small { font-size: 0.88rem; color: var(--ins-mute); margin: 0 0 1.1rem; line-height: 1.5; }
            .public-enrollment-mode .section-title-inside {
                font-family: 'Bebas Neue', 'Arial Narrow', sans-serif; font-weight: 400; font-size: 1.35rem;
                letter-spacing: 0.02em; color: var(--ins-teal-700); margin-bottom: 0.85rem;
            }
            .public-enrollment-mode .formation-selector-box {
                background: linear-gradient(180deg, #F4FBF9 0%, #fff 100%); border: 1px solid var(--ins-line);
                border-left: 4px solid var(--ins-teal-500); border-radius: 14px; padding: 1.1rem 1.25rem 0.4rem; margin: 0.75rem 0 0.5rem;
            }

            /* Campos: etiqueta legible encima, 44 px, separación uniforme */
            .public-enrollment-mode .form-grid { gap: 0 1.25rem; align-items: start; }
            .public-enrollment-mode .form-grid > .form-group,
            .public-enrollment-mode .form-group.border-labeled { margin: 0 0 1rem; }
            .public-enrollment-mode .file-preview-status:empty { display: none; }
            .public-enrollment-mode .form-group.border-labeled .form-label-overlay,
            .public-enrollment-mode .form-label-overlay-static {
                position: static; order: -1; background: none; padding: 0; margin: 0 0 0.4rem;
                font-family: inherit; font-size: 0.82rem; font-weight: 600; letter-spacing: 0; text-transform: none;
                text-decoration: none; color: var(--ins-mute); display: block; pointer-events: auto;
            }
            .public-enrollment-mode .form-group.border-labeled .form-input,
            .public-enrollment-mode .form-group.border-labeled .form-select,
            .public-enrollment-mode .form-group.border-labeled .form-textarea {
                min-height: 44px; padding: 0.6rem 0.85rem; font-size: 0.95rem; border-radius: 10px;
                border: 1px solid var(--ins-line); background-color: #FBFDFC; color: var(--ins-ink);
            }
            .public-enrollment-mode .form-group.border-labeled .form-textarea { min-height: 140px; line-height: 1.5; resize: vertical; }
            .public-enrollment-mode .form-group.border-labeled .form-input:hover,
            .public-enrollment-mode .form-group.border-labeled .form-select:hover,
            .public-enrollment-mode .form-group.border-labeled .form-textarea:hover { border-color: #C4D0CA; }
            .public-enrollment-mode .form-group.border-labeled .form-input:focus,
            .public-enrollment-mode .form-group.border-labeled .form-select:focus,
            .public-enrollment-mode .form-group.border-labeled .form-textarea:focus {
                background-color: #fff; border-color: var(--ins-teal-500); box-shadow: 0 0 0 4px rgba(28,160,147,0.14);
            }
            .public-enrollment-mode .form-group.border-labeled:focus-within .form-label-overlay { color: var(--ins-teal-700); }
            .public-enrollment-mode .form-input::placeholder,
            .public-enrollment-mode .form-textarea::placeholder { color: #A7B3AE; }
            .public-enrollment-mode .form-group.border-labeled select.form-select { background-position: right 0.85rem center; }

            /* Subidas: compactas y en línea con los campos */
            .public-enrollment-mode .form-group:has(> .upload-zone) { margin-bottom: 1rem; }
            .public-enrollment-mode .upload-zone-label {
                flex-direction: row; justify-content: flex-start; text-align: left; gap: 0.85rem; min-height: 44px;
                padding: 0.65rem 0.9rem; border: 1.5px dashed #C4D0CA; border-radius: 10px; background: #FBFDFC;
                display: grid; grid-template-columns: auto 1fr; grid-template-rows: auto auto; column-gap: 0.85rem; align-items: center;
            }
            .public-enrollment-mode .upload-zone-label:hover { border-color: var(--ins-teal-500); background: #F4FBF9; }
            .public-enrollment-mode .upload-icon {
                grid-row: 1 / span 2; width: 38px; height: 38px; border-radius: 10px; display: inline-flex; align-items: center;
                justify-content: center; background: var(--ins-teal-100); color: var(--ins-teal-700); font-size: 1rem; margin: 0;
            }
            .public-enrollment-mode .upload-text { font-size: 0.9rem; font-weight: 600; color: var(--ins-ink); margin: 0; }
            .public-enrollment-mode .upload-hint { font-size: 0.75rem; color: var(--ins-faint); margin: 0; }
            .public-enrollment-mode .photo-capture-section { border: 1px solid var(--ins-line); border-radius: 14px; padding: 1rem; background: var(--ins-sunken); gap: 1.25rem; }
            .public-enrollment-mode .photo-preview-box { border-radius: 12px; border: 1px solid var(--ins-line); background: #fff; }
            .public-enrollment-mode .btn-activate-camera { border-radius: 10px; }

            /* Ordenar preferencias */
            .public-enrollment-mode .dnd-item { border-radius: 10px; border: 1px solid var(--ins-line); background: #fff; padding: 0.7rem 0.9rem; }
            .public-enrollment-mode .dnd-item:hover { border-color: var(--ins-teal-500); box-shadow: 0 4px 12px -6px rgba(10,25,22,0.2); }

            /* Confirmación */
            .public-enrollment-mode .payment-instructions {
                background: linear-gradient(180deg, #F4FBF9 0%, #fff 100%); border: 1px solid var(--ins-line);
                border-left: 4px solid var(--ins-teal-500); border-radius: 14px; padding: 1.1rem 1.25rem;
            }
            .public-enrollment-mode .confirmation-checkboxes { display: grid; gap: 0.75rem; margin-top: 1.25rem; }
            .public-enrollment-mode .form-checkbox-group {
                margin: 0; padding: 0.95rem 1.1rem; border: 1px solid var(--ins-line); border-radius: 12px; background: #fff;
                align-items: center; transition: border-color 0.15s, background 0.15s;
            }
            .public-enrollment-mode .form-checkbox-group:has(.form-checkbox:checked) { border-color: var(--ins-teal-500); background: #F4FBF9; }
            .public-enrollment-mode .form-checkbox-group label { font-size: 0.93rem; color: var(--ins-ink); }
            .public-enrollment-mode .form-checkbox { width: 20px; height: 20px; border-radius: 6px; }
            .public-enrollment-mode .form-checkbox:checked { background: var(--ins-teal-600); border-color: var(--ins-teal-600); }
            .public-enrollment-mode .legal-disclaimer { border-radius: 12px; }

            /* Navegación inferior fija */
            .public-enrollment-mode .form-steps-nav {
                position: sticky; bottom: 0; z-index: 20; margin: 0 -2.5rem; padding: 0.9rem 2.5rem;
                background: rgba(255,255,255,0.94); backdrop-filter: blur(6px); border-top: 1px solid var(--ins-line);
                box-shadow: 0 -10px 24px -18px rgba(10,25,22,0.35);
            }
            .public-enrollment-mode .step-indicator { font-size: 0.72rem; letter-spacing: 0.12em; color: var(--ins-faint); }
            .public-enrollment-mode .btn { font-family: inherit; font-weight: 600; border-radius: 10px; padding: 0.7rem 1.3rem; font-size: 0.92rem; gap: 0.5rem; }
            .public-enrollment-mode .btn-prev { border-color: var(--ins-line); color: var(--ins-mute); }
            .public-enrollment-mode .btn-next { background: var(--ins-teal-600); box-shadow: 0 8px 18px -10px rgba(20,134,122,0.8); }
            .public-enrollment-mode .btn-next:hover { background: var(--ins-teal-700); }
            .public-enrollment-mode .btn-submit { background: var(--ins-teal-700); box-shadow: 0 8px 18px -10px rgba(14,107,98,0.8); }
            .public-enrollment-mode .btn-submit:hover { background: var(--ins-teal-900); }
            .public-enrollment-mode .btn-submit:disabled { background: var(--ins-sunken); color: var(--ins-faint); }

            @media (max-width: 850px) {
                .public-enrollment-mode .enrollment-form-grid { grid-template-columns: 1fr; }
                .public-enrollment-mode .enrollment-card-sidebar { padding: 1rem 1rem 0.75rem; }
                .public-enrollment-mode .sidebar-brand { margin-bottom: 0.75rem; padding-bottom: 0.75rem; }
                .public-enrollment-mode .tab-desc { display: none; }
                .public-enrollment-mode .enrollment-card-content { padding: 0 1rem; }
                .public-enrollment-mode .ins-progress, .public-enrollment-mode .form-steps-nav { margin: 0 -1rem; }
                .public-enrollment-mode .form-steps-nav { padding: 0.75rem 1rem; }
                .public-enrollment-mode .tab-item,
                .public-enrollment-mode .tab-item.active { background: transparent; box-shadow: none; padding: 0.25rem; margin: 0; }
                .public-enrollment-mode .tab-text { display: none; }
            }
            @media (max-width: 640px) {
                .public-enrollment-mode .form-grid > * { grid-column: auto !important; }
                .public-enrollment-mode .section-title { font-size: 1.6rem; }
                .public-enrollment-mode .btn { padding: 0.65rem 1rem; }
            }
        </style>
        `;
    },

    async init() {
        console.log('Initializing InscripcionView public page...');
        
        // Dynamically load FontAwesome and SweetAlert2 if they are not already loaded
        this.loadLibraries();

        // 1. Fetch formations from public api
        await this.loadFormations();
        await this.loadFormationTypes();

        // 2. Setup Step Navigation
        this.setupTabs();

        // 3. Setup Camera Controls
        this.setupCamera();

        // 4. Setup Form selectors & Drag & Drop
        this.setupSelectors();

        // 5. Setup file uploads
        this.setupFileUploads();

        // 6. Checkboxes & completes button
        this.setupCheckboxes();

        // 7. If token is present, hydrate existing enrollment
        if (this.token) {
            await this.hydrateEnrollment();
        }

        // Enhance after hydration so saved selections and locks are reflected.
        this.setupFormationPickers();

        // 8. Bind Guardar and Completar buttons
        document.getElementById('guardarBtn').onclick = () => this.saveEnrollment(false);
        document.getElementById('completarBtn').onclick = () => this.saveEnrollment(true);

        // 9. Bind Load Draft button and keydown events
        const cargarBtn = document.getElementById('cargarBorradorBtn');
        const tokenInput = document.getElementById('tokenCargarInput');
        if (cargarBtn && tokenInput) {
            const doLoad = () => {
                const tok = tokenInput.value.trim();
                if (!tok) {
                    SafeHTML.fire('Token Requerido', 'Por favor, introduce tu token de borrador.', 'warning');
                    return;
                }
                window.location.assign(`/inscribete/${encodeURIComponent(tok)}`);
            };
            cargarBtn.onclick = doLoad;
            tokenInput.onkeydown = (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    doLoad();
                }
            };
        }
    },

    loadLibraries() {
        // Typography is served locally by enrollment-editorial.css.

        // FontAwesome
        if (!document.querySelector('link[href*="font-awesome"]')) {
            const fa = document.createElement('link');
            fa.rel = 'stylesheet';
            fa.href = '/vendor/fontawesome/css/all.min.css';
            document.head.appendChild(fa);
        }
        
        // SweetAlert2
        if (typeof Swal === 'undefined') {
            const sw = document.createElement('script');
            sw.src = '/vendor/sweetalert2.js';
            document.head.appendChild(sw);
        }
    },

    // Types offered in the form (Plan de Estudios → Tipos, active ones only).
    formationTypes: [],
    ranksPreferences(typeId) { return !!this.formationTypes.find(t => t.id === typeId)?.ranksPreferences; },

    async loadFormationTypes() {
        try {
            const response = await fetch('/api/public/formation-types');
            const res = response.ok ? await response.json() : null;
            this.formationTypes = Array.isArray(res?.types) ? res.types : [];
        } catch (e) {
            console.error('Error fetching formation types:', e);
            this.formationTypes = [];
        }
        const select = document.getElementById('tipo_formation');
        if (!select) return;
        // Only types with some formation open for enrollment.
        this.formationTypes.filter(t => this.formations.some(f => f.type === t.id)).forEach(t => {
            const opt = document.createElement('option');
            opt.value = t.id;
            opt.textContent = t.name;
            select.appendChild(opt);
        });
    },

    async loadFormations() {
        try {
            const response = await fetch('/api/public/formations');
            if (response.ok) {
                const res = await response.json();
                if (res.success) {
                    this.formations = res.formations.filter(f => f.enrollmentOpen === true);
                }
            }
        } catch (e) {
            console.error('Error fetching public formations:', e);
        }
    },

    // The name the school advertises (set in Alumnado › Formaciones admisión), else the internal one.
    publicName(f) {
        return f.commercialName && f.commercialName !== 'null' ? f.commercialName : f.name;
    },

    setupFormationPickers() {
        this.formationPickers?.destroy();
        const controller = new AbortController(), cleanups = [], pickers = [];
        const on = (node, event, handler, options = {}) => node.addEventListener(event, handler, { ...options, signal: controller.signal });
        ['tipo_formation', 'formation_id'].forEach(id => {
            const select = document.getElementById(id);
            if (!select) return;
            const label = select.labels[0];
            const wrapper = document.createElement('div');
            wrapper.className = 'ins-choice';
            select.before(wrapper); wrapper.append(select);
            const originalTabIndex = select.getAttribute('tabindex');
            select.classList.add('ins-choice-native');
            select.tabIndex = -1; select.setAttribute('aria-hidden', 'true');
            const trigger = document.createElement('button');
            trigger.type = 'button'; trigger.id = `${id}-choice`; trigger.className = 'ins-choice-trigger';
            trigger.setAttribute('role', 'combobox'); trigger.setAttribute('aria-haspopup', 'listbox');
            trigger.setAttribute('aria-expanded', 'false'); trigger.setAttribute('aria-controls', `${id}-options`);
            const value = document.createElement('span'); value.id = `${id}-choice-value`;
            const arrow = document.createElement('span'); arrow.className = 'ins-choice-arrow'; arrow.setAttribute('aria-hidden', 'true');
            trigger.append(value, arrow);
            const panel = document.createElement('div'); panel.className = 'ins-choice-panel'; panel.hidden = true;
            const list = document.createElement('div'); list.id = `${id}-options`; list.setAttribute('role', 'listbox');
            const empty = document.createElement('p'); empty.className = 'ins-choice-empty'; empty.textContent = 'No hay formaciones disponibles.'; empty.hidden = true;
            panel.append(list, empty); wrapper.append(trigger, panel);
            if (label) {
                if (!label.id) label.id = `${id}-label`;
                label.htmlFor = trigger.id;
                trigger.setAttribute('aria-labelledby', `${label.id} ${value.id}`);
                list.setAttribute('aria-labelledby', label.id);
            }
            let options = [], active = -1, search = '', searchedAt = 0;
            const opened = () => !panel.hidden;
            const close = () => {
                panel.hidden = true; wrapper.classList.remove('is-open', 'opens-up');
                trigger.setAttribute('aria-expanded', 'false'); trigger.removeAttribute('aria-activedescendant');
                search = '';
            };
            function position() {
                if (!opened()) return;
                const rect = trigger.getBoundingClientRect();
                if (rect.bottom < 0 || rect.top > window.innerHeight) { close(); return; }
                const below = window.innerHeight - rect.bottom - 16, above = rect.top - 16;
                const up = below < 180 && above > below;
                wrapper.classList.toggle('opens-up', up);
                panel.style.maxHeight = `${Math.max(90, Math.min(300, up ? above : below))}px`;
            }
            function activate(index, scroll = false) {
                active = index;
                [...list.children].forEach((item, i) => item.classList.toggle('is-active', i === active));
                const item = list.children[active];
                if (item) {
                    trigger.setAttribute('aria-activedescendant', item.id);
                    // Scroll only the options, never the outer page.
                    if (scroll) {
                        if (item.offsetTop < panel.scrollTop) panel.scrollTop = item.offsetTop;
                        else if (item.offsetTop + item.offsetHeight > panel.scrollTop + panel.clientHeight) panel.scrollTop = item.offsetTop + item.offsetHeight - panel.clientHeight;
                    }
                } else trigger.removeAttribute('aria-activedescendant');
            }
            function sync() {
                const previous = options[active]?.value;
                value.textContent = (select.options[select.selectedIndex]?.textContent || 'Selecciona una opción').replace(/^--\s*|\s*--$/g, '');
                trigger.disabled = select.disabled;
                trigger.classList.toggle('is-placeholder', !select.value);
                trigger.classList.toggle('is-invalid', select.classList.contains('is-invalid'));
                trigger.setAttribute('aria-required', String(select.required));
                trigger.setAttribute('aria-invalid', String(select.classList.contains('is-invalid')));
                if (select.getAttribute('aria-describedby')) trigger.setAttribute('aria-describedby', select.getAttribute('aria-describedby'));
                wrapper.hidden = select.style.display === 'none' || select.hidden;
                if (trigger.disabled || wrapper.hidden) close();
                options = [...select.options].filter(option => option.value && !option.hidden);
                list.replaceChildren();
                options.forEach((option, index) => {
                    const item = document.createElement('div'); item.id = `${id}-option-${index}`;
                    item.className = 'ins-choice-option'; item.dataset.index = index;
                    item.setAttribute('role', 'option'); item.setAttribute('aria-selected', String(option.selected));
                    if (option.disabled) item.setAttribute('aria-disabled', 'true');
                    const text = document.createElement('span'); text.textContent = option.textContent;
                    const tick = document.createElement('span'); tick.className = 'ins-choice-tick'; tick.textContent = '✓'; tick.setAttribute('aria-hidden', 'true');
                    item.append(text, tick); list.append(item);
                });
                empty.hidden = options.length > 0;
                if (opened()) {
                    const index = options.findIndex(option => option.value === previous && !option.disabled);
                    activate(index >= 0 ? index : options.findIndex(option => !option.disabled)); position();
                }
            }
            function open() {
                sync();
                if (trigger.disabled || wrapper.hidden) return;
                pickers.forEach(picker => picker.close());
                panel.hidden = false; wrapper.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true');
                const selected = options.findIndex(option => option.selected && !option.disabled);
                position(); activate(selected >= 0 ? selected : options.findIndex(option => !option.disabled), true);
            }
            function choose(index) {
                const option = options[index];
                if (!option || option.disabled || select.disabled) return;
                const changed = select.value !== option.value;
                select.value = option.value; close();
                if (changed) {
                    select.dispatchEvent(new Event('input', { bubbles: true }));
                    select.dispatchEvent(new Event('change', { bubbles: true }));
                }
                sync(); trigger.focus({ preventScroll: true });
            }
            on(trigger, 'click', () => opened() ? close() : open());
            on(trigger, 'focus', sync);
            on(trigger, 'keydown', event => {
                if (event.key === 'Tab') { close(); return; }
                if (event.key === 'Escape') { if (opened()) { event.preventDefault(); event.stopPropagation(); close(); } return; }
                if (['Enter', ' '].includes(event.key)) {
                    event.preventDefault(); opened() ? choose(active) : open(); return;
                }
                if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
                    event.preventDefault(); const wasOpen = opened(); if (!wasOpen) open();
                    const enabled = options.map((option, index) => option.disabled ? -1 : index).filter(index => index >= 0);
                    const current = enabled.indexOf(active);
                    if (event.key === 'Home') activate(enabled[0] ?? -1, true);
                    else if (event.key === 'End') activate(enabled.at(-1) ?? -1, true);
                    else if (wasOpen) activate(enabled[Math.max(0, Math.min(enabled.length - 1, current + (event.key === 'ArrowDown' ? 1 : -1)))] ?? -1, true);
                    return;
                }
                if (event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
                    event.preventDefault(); if (!opened()) open();
                    const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
                    const now = Date.now(), letter = normalize(event.key);
                    search = now - searchedAt > 700 || search === letter ? letter : search + letter; searchedAt = now;
                    const indices = options.map((_, index) => (index + active + 1) % options.length);
                    const index = indices.find(index => !options[index].disabled && normalize(options[index].textContent.trim()).startsWith(search));
                    if (index !== undefined) activate(index, true);
                }
            });
            on(list, 'pointerdown', event => { if (event.pointerType === 'mouse') event.preventDefault(); });
            on(list, 'click', event => { const item = event.target.closest('[data-index]'); if (item) choose(Number(item.dataset.index)); });
            on(wrapper, 'focusout', event => { if (!wrapper.contains(event.relatedTarget)) close(); });
            on(document, 'pointerdown', event => { if (!wrapper.contains(event.target)) close(); });
            on(window, 'resize', position);
            on(document, 'scroll', event => { if (!panel.contains(event.target)) position(); }, { capture: true, passive: true });
            on(select, 'change', sync); on(select, 'input', sync);
            on(select, 'focus', () => trigger.focus({ preventScroll: true }));
            on(select, 'invalid', event => { event.preventDefault(); select.classList.add('is-invalid'); sync(); trigger.focus({ preventScroll: true }); });
            let resetTimer;
            if (select.form) on(select.form, 'reset', () => {
                clearTimeout(resetTimer);
                resetTimer = setTimeout(() => { close(); sync(); }, 0);
            });
            const observer = new MutationObserver(sync);
            observer.observe(select, { attributes: true, childList: true, subtree: true, characterData: true });
            pickers.push({ close }); sync();
            cleanups.push(() => {
                clearTimeout(resetTimer); observer.disconnect(); wrapper.before(select); wrapper.remove();
                select.classList.remove('ins-choice-native'); select.removeAttribute('aria-hidden');
                if (originalTabIndex === null) select.removeAttribute('tabindex'); else select.setAttribute('tabindex', originalTabIndex);
                if (label) label.htmlFor = id;
            });
        });
        this.formationPickers = { destroy() { controller.abort(); cleanups.forEach(cleanup => cleanup()); } };
    },


    setupSelectors() {
        const selectTipo = document.getElementById("tipo_formation");
        const selectFormation = document.getElementById("formation_id");
        const dndBlock = document.getElementById("diplomatura_dnd");
        const container = document.getElementById("dnd_container");
        const inputOrden = document.getElementById("orden_diplomaturas");
        const inputDiplomaId = document.getElementById("formation_id_diploma");

        const updatePlaceholder = (tipo) => {
            const first = selectFormation.querySelector('option:first-child');
            if (!first) return;
            const type = this.formationTypes.find(t => t.id === tipo);
            first.textContent = type ? `Elige ${type.name.toLowerCase()} para matricularte` : "-- Selecciona la formación --";
        };

        const filterFormations = (tipo) => {
            SafeHTML.set(selectFormation, '<option value="">-- Selecciona la formación --</option>');
            if (this.ranksPreferences(tipo)) {
                selectFormation.style.display = "none";
                selectFormation.removeAttribute("required");
                selectFormation.disabled = true;
                return;
            }

            selectFormation.style.display = "block";
            selectFormation.disabled = false;
            selectFormation.setAttribute("required", "required");

            const filtered = this.formations.filter(f => f.type === tipo);
            filtered.forEach(f => {
                const opt = document.createElement('option');
                opt.value = f.id;
                opt.textContent = this.publicName(f);
                selectFormation.appendChild(opt);
            });

            updatePlaceholder(tipo);
        };

        const updateDndOrder = () => {
            const items = container.querySelectorAll(".dnd-item");
            inputOrden.value = [...items]
                .map((el, i) => (i + 1) + ". " + el.dataset.nombre)
                .join(" | ");

            items.forEach((el, i) => {
                const spanNum = el.querySelector(".orden-num");
                if (spanNum) spanNum.textContent = (i + 1) + ". ";
                const up = el.querySelector('[data-preference-move="up"]');
                const down = el.querySelector('[data-preference-move="down"]');
                if (up) up.disabled = i === 0;
                if (down) down.disabled = i === items.length - 1;
            });

            if (items.length > 0) {
                inputDiplomaId.value = items[0].dataset.id;
            }
        };

        selectTipo.onchange = () => {
            const tipo = selectTipo.value;
            const formationGroup = document.getElementById('formation_select_group');
            if (formationGroup) formationGroup.style.display = this.ranksPreferences(tipo) ? 'none' : '';
            if (this.ranksPreferences(tipo)) {
                dndBlock.style.display = "block";
                selectFormation.style.display = "none";
                selectFormation.removeAttribute("required");
                selectFormation.disabled = true;
                
                // The applicant orders the open formations of this type by preference.
                SafeHTML.set(container, '');
                const diplomas = this.formations.filter(f => f.type === tipo);
                diplomas.forEach(formation => {
                    const d = { id: formation.id, name: this.publicName(formation) };
                    const item = document.createElement('div');
                    item.className = 'dnd-item';
                    item.draggable = true;
                    item.dataset.nombre = d.name;
                    item.dataset.id = d.id;
                    SafeHTML.set(item, `<i class="fas fa-grip-vertical draggable-grip" aria-hidden="true"></i><span class="orden-num"></span><span class="ins-preference-name">${Utils.sanitizeHTML(d.name)}</span><span class="ins-order-buttons"><button type="button" data-preference-move="up" aria-label="Subir ${Utils.sanitizeHTML(d.name)}">↑</button><button type="button" data-preference-move="down" aria-label="Bajar ${Utils.sanitizeHTML(d.name)}">↓</button></span>`);
                    container.appendChild(item);
                });
                
                // Set order
                updateDndOrder();
            } else {
                dndBlock.style.display = "none";
                selectFormation.style.display = "block";
                selectFormation.disabled = false;
                selectFormation.setAttribute("required", "required");
                inputOrden.value = "";
                inputDiplomaId.value = "";
                filterFormations(tipo);
            }
        };

        // Button alternatives also work on touchscreens and with the keyboard.
        container.addEventListener('click', (event) => {
            const button = event.target.closest('[data-preference-move]');
            if (!button || button.disabled || this.isLocked) return;
            const item = button.closest('.dnd-item');
            const up = button.dataset.preferenceMove === 'up';
            const sibling = up ? item.previousElementSibling : item.nextElementSibling;
            if (!sibling) return;
            container.insertBefore(up ? item : sibling, up ? sibling : item);
            updateDndOrder();
            const focusButton = item.querySelector(`[data-preference-move="${up ? 'up' : 'down'}"]`);
            (focusButton.disabled ? item.querySelector('[data-preference-move]:not(:disabled)') : focusButton)?.focus();
        });

        // Enable HTML5 drag and drop fallback for ordering
        let dragSrcEl = null;

        container.addEventListener('dragstart', (e) => {
            const target = e.target.closest('.dnd-item');
            if (!target) return;
            dragSrcEl = target;
            e.dataTransfer.effectAllowed = 'move';
            e.dataTransfer.setData('text/html', target.innerHTML);
            target.style.opacity = '0.4';
        });

        container.addEventListener('dragover', (e) => {
            e.preventDefault();
            return false;
        });

        container.addEventListener('drop', (e) => {
            e.stopPropagation();
            const target = e.target.closest('.dnd-item');
            if (dragSrcEl && target && dragSrcEl !== target) {
                // Swap HTML content and dataset details
                const tempHTML = target.innerHTML;
                const tempNombre = target.dataset.nombre;
                const tempId = target.dataset.id;

                SafeHTML.set(target, dragSrcEl.innerHTML);
                target.dataset.nombre = dragSrcEl.dataset.nombre;
                target.dataset.id = dragSrcEl.dataset.id;

                SafeHTML.set(dragSrcEl, tempHTML);
                dragSrcEl.dataset.nombre = tempNombre;
                dragSrcEl.dataset.id = tempId;

                updateDndOrder();
            }
            return false;
        });

        container.addEventListener('dragend', (e) => {
            const items = container.querySelectorAll('.dnd-item');
            items.forEach(item => item.style.opacity = '1');
        });
    },

    setupTabs() {
        const tabs = document.querySelectorAll('#matriculaTabs .tab-item');
        const prevBtn = document.getElementById('prevBtn');
        const nextBtn = document.getElementById('nextBtn');
        const completarBtn = document.getElementById('completarBtn');
        const indicator = document.getElementById('stepIndicator');

        const getVisibleTabs = () => {
            return Array.from(tabs).filter(t => t.style.display !== 'none');
        };

        const showTab = (index, focusHeading = false) => {
            this.currentTab = index;
            const visible = getVisibleTabs();
            const currentTabEl = visible[this.currentTab];

            tabs.forEach(t => {
                t.classList.remove('active');
                t.classList.remove('completed');
                t.removeAttribute('aria-current');
            });
            
            currentTabEl.classList.add('active');
            currentTabEl.setAttribute('aria-current', 'step');
            
            // Mark tabs as completed based on their real validity
            this.updateStepIndicators();

            // Update step numbers dynamically for visible tabs
            visible.forEach((t, idx) => {
                const numEl = t.querySelector('.step-number');
                if (numEl) numEl.textContent = idx + 1;
            });

            const tabIndex = parseInt(currentTabEl.dataset.tab);
            document.querySelectorAll('.tab-pane').forEach(pane => pane.classList.remove('active'));
            document.getElementById(`pane-${tabIndex}`).classList.add('active');

            // Prev button visibility
            prevBtn.style.visibility = this.currentTab === 0 ? 'hidden' : 'visible';
            
            if (this.currentTab === visible.length - 1) {
                nextBtn.style.display = 'none';
                if (!this.isLocked && !this.isPaymentActive) {
                    completarBtn.style.display = 'inline-block';
                } else {
                    completarBtn.style.display = 'none';
                }
            } else {
                nextBtn.style.display = 'inline-block';
                completarBtn.style.display = 'none';
            }
            
            indicator.textContent = `Paso ${this.currentTab + 1} de ${visible.length}`;
            const counter = document.getElementById('insStepCounter');
            if (counter) counter.textContent = indicator.textContent;
            const heading = document.getElementById('insStepTitle');
            if (heading) {
                heading.textContent = ['Tu formación y tus datos.', 'Datos de tu tutor o tutora.', 'Cómo podemos encontrarte.', 'Queremos conocerte.', 'Revisa tu solicitud.'][tabIndex];
                if (focusHeading) {
                    heading.focus({preventScroll: true});
                }
            }
            const progress = document.getElementById('insProgress');
            if (progress) progress.style.width = `${Math.round(((this.currentTab + 1) / visible.length) * 100)}%`;
        };
        this.showTab = showTab;

        prevBtn.onclick = () => {
            if (this.currentTab > 0) showTab(this.currentTab - 1, true);
        };

        nextBtn.onclick = () => {
            const visible = getVisibleTabs();
            if (this.currentTab < visible.length - 1) showTab(this.currentTab + 1, true);
        };

        tabs.forEach((tab, index) => {
            tab.onclick = () => {
                const visible = getVisibleTabs();
                const vIndex = visible.indexOf(tab);
                if (vIndex !== -1) showTab(vIndex, true);
            };
            tab.onkeydown = (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    tab.click();
                }
            };
        });

        // Birthdate age check triggers tutor tab
        const dobInput = document.getElementById('fecha_nacimiento');
        const tutorTab = document.getElementById('tabTutorItem');
        const tutorPane = document.getElementById('pane-1');

        const calculateAge = (dobString) => {
            if (!dobString) return 100;
            const dob = new Date(dobString);
            const diff = Date.now() - dob.getTime();
            const age = new Date(diff);
            return Math.abs(age.getUTCFullYear() - 1970);
        };

        const toggleTutorRequired = (required) => {
            const fields = tutorPane.querySelectorAll('input, select');
            fields.forEach(f => {
                if (required) {
                    f.setAttribute('required', 'required');
                } else {
                    f.removeAttribute('required');
                }
            });
        };

        dobInput.onchange = () => {
            const age = calculateAge(dobInput.value);
            if (age < 18) {
                tutorTab.style.display = 'block';
                toggleTutorRequired(true);
            } else {
                tutorTab.style.display = 'none';
                toggleTutorRequired(false);
                // Clear fields
                tutorPane.querySelectorAll('input, select').forEach(f => f.value = '');
            }
            
            // Adjust step count
            const visible = getVisibleTabs();
            if (this.currentTab >= visible.length) {
                showTab(visible.length - 1);
            } else {
                showTab(this.currentTab);
            }
        };

        // Bind dynamic validation listeners to inputs/selects/textareas/checkboxes
        const form = document.getElementById('miFormulario');
        if (form) {
            form.addEventListener('input', (e) => {
                const target = e.target;
                if (target && target.value.trim()) {
                    target.classList.remove('is-invalid');
                    if (target.id === 'presentacionTexto') {
                        const zone = document.getElementById('zone-hablanos_documento');
                        if (zone) zone.classList.remove('is-invalid');
                    }
                    if (target.id === 'estudiosTexto') {
                        const zone = document.getElementById('zone-estudiosArchivo');
                        if (zone) zone.classList.remove('is-invalid');
                    }
                }
                this.updateStepIndicators();
            });
            form.addEventListener('change', (e) => {
                const target = e.target;
                if (target && (target.value || target.checked)) {
                    target.classList.remove('is-invalid');
                    if (target.id === 'tipo_formation') {
                        const selectFormation = document.getElementById("formation_id");
                        const dndContainer = document.getElementById("dnd_container");
                        if (selectFormation) selectFormation.classList.remove('is-invalid');
                        if (dndContainer) dndContainer.classList.remove('is-invalid');
                    }
                }
                this.updateStepIndicators();
            });
        }

        // Initialize first tab explicitly
        showTab(0);
    },

    setupCamera() {
        const activateBtn = document.getElementById('activarCamaraBtn');
        const base64Input = document.getElementById('fotoBase64');
        const photoPreview = document.getElementById('photo-image-preview');
        const placeholder = document.getElementById('photo-placeholder');

        if (!activateBtn) return;

        activateBtn.onclick = () => {
            SafeHTML.fire({
                title: 'Capturar Foto de Perfil',
                html: `
                    <div style="position: relative; width: 320px; height: 240px; margin: 0 auto 15px auto; border-radius: 12px; overflow: hidden; border: 2px solid var(--primary-color); background: #000; box-shadow: var(--shadow-md);">
                        <video id="popup-video" autoplay playsinline style="width: 100%; height: 100%; object-fit: cover;"></video>
                        <div style="position: absolute; inset: 0; pointer-events: none; border: 2px dashed rgba(255, 255, 255, 0.4); border-radius: 10px; margin: 10px;">
                            <div style="position: absolute; top: 10px; right: 10px; background: rgba(239, 68, 68, 0.85); color: white; padding: 2px 8px; border-radius: 99px; font-size: 0.75rem; font-weight: 700; display: flex; align-items: center; gap: 4px;">
                                <span style="width: 6px; height: 6px; background: white; border-radius: 50%; display: inline-block; animation: pulse 1.5s infinite;"></span> LIVE
                            </div>
                        </div>
                    </div>
                    <canvas id="popup-canvas" style="display: none;"></canvas>
                    <style ${SafeHTML.styleAttr}>
                        @keyframes pulse {
                            0% { opacity: 0.3; }
                            50% { opacity: 1; }
                            100% { opacity: 0.3; }
                        }
                    </style>
                `,
                showCancelButton: true,
                confirmButtonText: '<i class="fas fa-camera"></i> Capturar',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: '#10b981',
                cancelButtonColor: '#64748b',
                allowOutsideClick: false,
                didOpen: () => {
                    const videoEl = document.getElementById('popup-video');
                    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                        navigator.mediaDevices.getUserMedia({ video: { width: 640, height: 480 } })
                            .then((s) => {
                                this.webcamStream = s;
                                videoEl.srcObject = s;
                                videoEl.play();
                            })
                            .catch((err) => {
                                console.error('Error accessing camera:', err);
                                Swal.showValidationMessage('No se pudo acceder a la cámara. Revisa los permisos.');
                            });
                    } else {
                        Swal.showValidationMessage('El navegador no soporta acceso a la cámara.');
                    }
                },
                willClose: () => {
                    if (this.webcamStream) {
                        this.webcamStream.getTracks().forEach(track => track.stop());
                        this.webcamStream = null;
                    }
                },
                preConfirm: () => {
                    const videoEl = document.getElementById('popup-video');
                    const canvasEl = document.getElementById('popup-canvas');
                    if (!videoEl || !canvasEl) return false;
                    
                    const context = canvasEl.getContext('2d');
                    canvasEl.width = 640;
                    canvasEl.height = 480;
                    context.drawImage(videoEl, 0, 0, 640, 480);
                    
                    const dataURL = canvasEl.toDataURL('image/jpeg');
                    return dataURL;
                }
            }).then((result) => {
                if (result.isConfirmed && result.value) {
                    const dataURL = result.value;
                    base64Input.value = dataURL;
                    photoPreview.src = dataURL;
                    photoPreview.style.display = 'block';
                    placeholder.style.display = 'none';

                    const fotoZone = document.getElementById('zone-foto_subida');
                    if (fotoZone) fotoZone.classList.remove('is-invalid');
                    this.updateStepIndicators();

                    SafeHTML.fire({
                        icon: 'success',
                        title: 'Foto capturada con éxito',
                        text: 'Presiona "Guardar borrador" para registrar los cambios.',
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    });
                }
            });
        };
    },

    setupFileUploads() {
        const handleUpload = this.handleUpload = async (inputEl, fieldName, previewEl) => {
            const file = inputEl.files[0];
            if (!file) return;

            // Enforce max size (20MB)
            if (file.size > 20 * 1024 * 1024) {
                SafeHTML.fire('Archivo muy grande', 'El archivo no debe superar los 20MB.', 'error');
                inputEl.value = '';
                return;
            }

            try {
                SafeHTML.set(previewEl, `<i class="fas fa-spinner fa-spin"></i> Subiendo ${Utils.sanitizeHTML(file.name)}...`);
                
                const uploadToken = InscripcionView.token || 'temporary';
                const response = await fetch(`/api/public/enrollment/upload?field=${fieldName}`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/octet-stream', 'X-Enrollment-Token': uploadToken },
                    body: file
                });

                if (!response.ok) throw new Error('Subida fallida');
                
                const res = await response.json();
                if (res.success) {
                    InscripcionView.filesUploaded[fieldName] = res.path;
                    SafeHTML.set(previewEl, `<i class="fas fa-check-circle"></i> Archivo subido: <a href="/${res.path}" target="_blank" class="text-success">${Utils.sanitizeHTML(file.name)}</a>`);
                    
                    if (fieldName === 'foto') {
                        const photoPreview = document.getElementById('photo-image-preview');
                        const placeholder = document.getElementById('photo-placeholder');
                        photoPreview.src = `/${res.path}?t=${Date.now()}`;
                        photoPreview.style.display = 'block';
                        placeholder.style.display = 'none';
                    }

                    this.updateStepIndicators();
                    const mapZone = {
                        dni: 'zone-dni_subido',
                        dniReverso: 'zone-dni_reverso',
                        foto: 'zone-foto_subida',
                        presentacion: 'zone-hablanos_documento',
                        estudios: 'zone-estudiosArchivo'
                    };
                    const zoneEl = document.getElementById(mapZone[fieldName]);
                    if (zoneEl) {
                        zoneEl.classList.remove('is-invalid');
                        if (fieldName === 'presentacion') {
                            const txt = document.getElementById('presentacionTexto');
                            if (txt) txt.classList.remove('is-invalid');
                        }
                        if (fieldName === 'estudios') {
                            const txt = document.getElementById('estudiosTexto');
                            if (txt) txt.classList.remove('is-invalid');
                        }
                    }

                    SafeHTML.fire({
                        icon: 'success',
                        title: 'Archivo subido',
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 2000
                    });
                } else {
                    throw new Error(res.error || 'Error del servidor');
                }
            } catch (err) {
                console.error(err);
                SafeHTML.set(previewEl, `<span class="text-danger"><i class="fas fa-times-circle"></i> Subida fallida</span>`);
                SafeHTML.fire('Error de Subida', err.message || 'Hubo un error al subir el archivo.', 'error');
            }
        };

        // Bind events
        document.getElementById('dni_subido').onchange = (e) => {
            handleUpload(e.target, 'dni', document.getElementById('dni_preview_link'));
        };
        document.getElementById('dni_reverso').onchange = (e) => {
            handleUpload(e.target, 'dniReverso', document.getElementById('dni_reverso_preview_link'));
        };
        // Phones and tablets: photograph each side of the ID with the camera, as banking apps do.
        if (this.canCaptureId()) document.querySelectorAll('.ins-camera-btn').forEach(button => { button.hidden = false; });
        
        document.getElementById('foto_subida').onchange = (e) => {
            handleUpload(e.target, 'foto', document.createElement('div')); // Inline display takes care of photo preview
        };
        
        document.getElementById('hablanos_documento').onchange = (e) => {
            handleUpload(e.target, 'presentacion', document.getElementById('presentacion_preview_link'));
        };

        document.getElementById('estudiosArchivo').onchange = (e) => {
            handleUpload(e.target, 'estudios', document.getElementById('estudios_preview_link'));
        };
    },

    canCaptureId() {
        return !!(navigator.mediaDevices?.getUserMedia && window.matchMedia?.('(pointer: coarse)').matches);
    },

    // Full-screen camera with an ID-card frame, as banking apps do: the photo is cropped to
    // exactly the frame shown on screen, checked by the applicant (use / retake) and then
    // uploaded like any chosen file. The frame follows the screen when the phone is turned.
    async captureId(field) {
        if (!navigator.mediaDevices?.getUserMedia || this._idcam) return;
        const side = field === 'dniReverso' ? 'trasera' : 'delantera';
        const previewId = field === 'dniReverso' ? 'dni_reverso_preview_link' : 'dni_preview_link';
        const overlay = document.createElement('div');
        overlay.className = 'idcam-overlay';
        overlay.setAttribute('role', 'dialog'); overlay.setAttribute('aria-modal', 'true'); overlay.setAttribute('aria-label', `Foto del DNI, cara ${side}`);
        document.body.appendChild(overlay);
        // Real full screen where the browser allows it (Android: hides the address bar and the
        // system bars); it must be asked for within the tap, before anything is awaited.
        try { overlay.requestFullscreen?.({navigationUI: 'hide'})?.catch?.(() => {}); } catch {}
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        const state = this._idcam = {field, side, previewId, overlay, stream: null, blob: null, previousOverflow};
        state.onResize = () => this.layoutIdCamera();
        window.addEventListener('resize', state.onResize);
        window.addEventListener('orientationchange', state.onResize);
        window.visualViewport?.addEventListener('resize', state.onResize);
        document.addEventListener('fullscreenchange', state.onResize);
        state.onKey = event => { if (event.key === 'Escape') this.closeIdCamera(); };
        document.addEventListener('keydown', state.onKey);
        await this.openIdCamera();
    },

    async openIdCamera() {
        const state = this._idcam; if (!state) return;
        state.blob = null;
        SafeHTML.set(state.overlay, `
            <video class="idcam-video"></video>
            <div class="idcam-card" aria-hidden="true"></div>
            <div class="idcam-top">
                <strong>DNI · cara ${state.side}</strong>
                <span>Encuadra la tarjeta dentro del marco, con buena luz y sin reflejos.</span>
            </div>
            <div class="idcam-bottom">
                <button type="button" class="idcam-text-btn" ${UIEvents.attr("click", function(event,captured){InscripcionView.closeIdCamera();}, [])}>Cancelar</button>
                <button type="button" class="idcam-shutter" aria-label="Capturar" disabled ${UIEvents.attr("click", function(event,captured){InscripcionView.takeIdPhoto();}, [])}><span></span></button>
                <span class="idcam-spacer"></span>
            </div>
            <p class="idcam-error" role="alert" hidden>No se pudo abrir la cámara. Revisa los permisos del navegador o sube un archivo.</p>`);
        const video = state.overlay.querySelector('.idcam-video');
        video.setAttribute('playsinline', ''); video.muted = true;
        try {
            state.stream = state.stream || await navigator.mediaDevices.getUserMedia({audio: false, video: {facingMode: {ideal: 'environment'}, width: {ideal: 1920}, height: {ideal: 1080}}});
            if (this._idcam !== state) { state.stream.getTracks().forEach(track => track.stop()); return; }
            video.srcObject = state.stream; await video.play();
            this.layoutIdCamera();
            state.overlay.querySelector('.idcam-shutter').disabled = false;
        } catch {
            const error = state.overlay.querySelector('.idcam-error'); if (error) error.hidden = false;
        }
    },

    // The frame: ID-card proportions (85.6 × 54 mm), as big as the screen allows. Turned
    // sideways, the text sits in a left column and the shutter in a right one (22 % / 18 %
    // of the width, as in the CSS), so the frame is centred in the space between them.
    idFrameRect() {
        const {W, H} = this.idCameraSize();
        if (W > H) {
            const left = W * 0.22, right = W * 0.18, room = W - left - right;
            const w = Math.min(room * 0.94, H * 0.84 * 1.586), h = w / 1.586;
            return {x: left + (room - w) / 2, y: (H - h) / 2, w, h};
        }
        const w = Math.min(W * 0.92, H * 0.5 * 1.586), h = w / 1.586;
        return {x: (W - w) / 2, y: (H - h) / 2, w, h};
    },

    // Size of the camera view: the overlay itself when shown, else the visible viewport.
    idCameraSize() {
        const box = this._idcam?.overlay?.getBoundingClientRect();
        if (box?.width && box?.height) return {W: box.width, H: box.height};
        return {W: window.visualViewport?.width || window.innerWidth, H: window.visualViewport?.height || window.innerHeight};
    },

    layoutIdCamera() {
        const card = this._idcam?.overlay.querySelector('.idcam-card'); if (!card) return;
        const r = this.idFrameRect();
        Object.assign(card.style, {left: `${r.x}px`, top: `${r.y}px`, width: `${r.w}px`, height: `${r.h}px`});
    },

    takeIdPhoto() {
        const state = this._idcam; if (!state) return;
        const video = state.overlay.querySelector('.idcam-video');
        if (!video?.videoWidth) return;
        // The video covers the screen (object-fit: cover): map the frame back to video pixels.
        const {W, H} = this.idCameraSize(), vw = video.videoWidth, vh = video.videoHeight;
        const scale = Math.max(W / vw, H / vh), ox = (W - vw * scale) / 2, oy = (H - vh * scale) / 2;
        const r = this.idFrameRect();
        const sx = Math.max(0, (r.x - ox) / scale), sy = Math.max(0, (r.y - oy) / scale);
        const sw = Math.min(vw - sx, r.w / scale), sh = Math.min(vh - sy, r.h / scale);
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(sw); canvas.height = Math.round(sh);
        canvas.getContext('2d').drawImage(video, sx, sy, sw, sh, 0, 0, canvas.width, canvas.height);
        canvas.toBlob(blob => {
            if (!blob || this._idcam !== state) return;
            state.blob = blob;
            const reader = new FileReader();
            reader.onload = () => this.reviewIdPhoto(reader.result); // data: URL (the sanitiser drops blob:)
            reader.readAsDataURL(blob);
        }, 'image/jpeg', 0.92);
    },

    reviewIdPhoto(dataUrl) {
        const state = this._idcam; if (!state) return;
        SafeHTML.set(state.overlay, `
            <div class="idcam-review">
                <div class="idcam-top"><strong>¿Se lee bien?</strong><span>Comprueba que se ven bien los datos y que no hay reflejos.</span></div>
                <img src="${dataUrl}" alt="Foto del DNI, cara ${state.side}" class="idcam-photo">
                <div class="idcam-bottom idcam-review-actions">
                    <button type="button" class="idcam-text-btn" ${UIEvents.attr("click", function(event,captured){InscripcionView.openIdCamera();}, [])}><i class="fas fa-rotate-left"></i> Repetir</button>
                    <button type="button" class="idcam-use-btn" ${UIEvents.attr("click", function(event,captured){InscripcionView.useIdPhoto();}, [])}><i class="fas fa-check"></i> Usar esta foto</button>
                </div>
            </div>`);
    },

    async useIdPhoto() {
        const state = this._idcam; if (!state?.blob) return;
        const file = new File([state.blob], `dni-${state.side}.jpg`, {type: 'image/jpeg'});
        this.closeIdCamera();
        await this.handleUpload?.({files: [file], value: ''}, state.field, document.getElementById(state.previewId));
    },

    closeIdCamera() {
        const state = this._idcam; if (!state) return;
        this._idcam = null;
        state.stream?.getTracks().forEach(track => track.stop());
        window.removeEventListener('resize', state.onResize);
        window.removeEventListener('orientationchange', state.onResize);
        window.visualViewport?.removeEventListener('resize', state.onResize);
        document.removeEventListener('fullscreenchange', state.onResize);
        if (document.fullscreenElement === state.overlay) document.exitFullscreen?.().catch?.(() => {});
        document.removeEventListener('keydown', state.onKey);
        document.body.style.overflow = state.previousOverflow;
        state.overlay.remove();
    },

    setupCheckboxes() {
        const privacidad = document.getElementById('privacidadCheck');
        const normas = document.getElementById('normasCheck');
        const completeBtn = document.getElementById('completarBtn');

        const updateBtnState = () => {
            completeBtn.disabled = !(privacidad.checked && normas.checked);
        };

        privacidad.onchange = updateBtnState;
        normas.onchange = updateBtnState;
    },

    // Texts from Ajustes (Privacidad, Normativa): one paragraph per blank line; a short
    // "Label:" at the start of a paragraph is shown in bold. Always escaped.
    paragraphsHtml(text, emptyMessage) {
        const clean = String(text || '').trim();
        if (!clean) return emptyMessage ? `<p>${emptyMessage}</p>` : '';
        return clean.split(/\n\s*\n/).map(paragraph => {
            const match = paragraph.match(/^([^:\n]{1,40}):\s*([\s\S]*)$/);
            const lines = value => Utils.sanitizeHTML(value).replace(/\n/g, '<br>');
            return match ? `<p><strong>${lines(match[1])}:</strong> ${lines(match[2])}</p>` : `<p>${lines(paragraph)}</p>`;
        }).join('');
    },

    privacyHtml() {
        return this.paragraphsHtml(SchoolService.get('privacyText'),
            SchoolService.get('privacyPdfUrl') ? '' : 'El centro todavía no ha publicado su política de privacidad. Consulta con la secretaría antes de enviar la solicitud.');
    },

    // Uploaded PDF of a document (privacy, rules), or '' (served as a download, never inline).
    pdfUrl(slot) {
        const url = SchoolService.get(slot);
        return /^\/school-assets\/[0-9a-f-]{36}\.pdf$/.test(url) ? url : '';
    },

    hasRules() {
        return !!(SchoolService.get('rulesText').trim() || SchoolService.get('rulesPdfUrl'));
    },

    // Text in the window; «Descargar PDF» next to «Cerrar» when a PDF was uploaded.
    showDocumentModal(title, bodyHtml, slot) {
        if (typeof Swal === 'undefined') return;
        const pdf = this.pdfUrl(slot);
        SafeHTML.fire({
            title,
            html: `<div style="text-align: left; font-size: 0.9rem; max-height: 400px; overflow-y: auto; padding-right: 10px;">${bodyHtml}</div>`,
            confirmButtonText: 'Cerrar',
            showDenyButton: !!pdf,
            denyButtonText: '<i class="fas fa-file-pdf"></i> Descargar PDF',
            denyButtonColor: '#0E6B62',
            preDeny: () => {
                const link = document.createElement('a');
                link.href = pdf; link.download = ''; link.rel = 'noopener';
                document.body.appendChild(link); link.click(); link.remove();
                return false; // keep the window open
            }
        });
    },

    showPrivacidadModal() {
        this.showDocumentModal('Política de Privacidad', this.privacyHtml(), 'privacyPdfUrl');
    },

    showNormativaModal() {
        this.showDocumentModal('Normativa de la escuela', this.paragraphsHtml(SchoolService.get('rulesText'),
            SchoolService.get('rulesPdfUrl') ? 'Puedes descargar la normativa completa en PDF.' : 'El centro todavía no ha publicado su normativa. Consulta con la secretaría antes de enviar la solicitud.'), 'rulesPdfUrl');
    },

    async hydrateEnrollment() {
        try {
            const response = await fetch('/api/public/enrollment/current', { headers: { 'X-Enrollment-Token': this.token }, cache: 'no-store' });
            if (!response.ok) {
                await SafeHTML.fire('Enlace no disponible', 'La solicitud está cerrada, el enlace ha caducado o no es válido. Contacta con secretaría.', 'warning');
                return;
            }

            const res = await response.json();
            if (res.success && res.enrollment) {
                const en = res.enrollment;
                
                // Hydrate fields
                document.getElementById('tipo_formation').value = en.tipoFormacion || '';
                // Trigger change to load options
                document.getElementById('tipo_formation').dispatchEvent(new Event('change'));

                // Hydrate formation ID or diploma options
                if (this.ranksPreferences(en.tipoFormacion)) {
                    document.getElementById('orden_diplomaturas').value = en.ordenDiplomaturas || '';
                    document.getElementById('formation_id_diploma').value = en.formationId || '';
                    
                    // Order dnd items
                    if (en.ordenDiplomaturas) {
                        const nombres = en.ordenDiplomaturas.split('|').map(n => n.replace(/^\s*\d+\.\s*/, '').trim());
                        const container = document.getElementById("dnd_container");
                        const items = Array.from(container.querySelectorAll(".dnd-item"));
                        nombres.forEach(nombre => {
                            const item = items.find(i => i.dataset.nombre === nombre);
                            if (item) container.appendChild(item);
                        });
                        
                        // Recalculate indicators
                        items.forEach((el, i) => {
                            const spanNum = el.querySelector(".orden-num");
                            if (spanNum) spanNum.textContent = (i + 1) + ". ";
                        });
                    }
                } else {
                    document.getElementById('formation_id').value = en.formationId || '';
                }

                document.getElementById('nombre').value = en.nombre || '';
                document.getElementById('apellidos').value = en.apellidos || '';
                document.getElementById('dni').value = en.dni || '';
                document.getElementById('fecha_nacimiento').value = en.fechaNacimiento || '';
                document.getElementById('fecha_nacimiento').dispatchEvent(new Event('change')); // Trigger age calculations
                document.getElementById('sexo').value = en.sexo || '';
                document.getElementById('como_nos_conociste').value = en.comoNosConociste || '';

                // Hydrate photo preview
                if (en.foto) {
                    this.filesUploaded.foto = en.foto;
                    const photoPreview = document.getElementById('photo-image-preview');
                    const placeholder = document.getElementById('photo-placeholder');
                    photoPreview.src = `/${en.foto}?t=${Date.now()}`;
                    photoPreview.style.display = 'block';
                    placeholder.style.display = 'none';
                }

                // File links
                if (en.dniFile) {
                    this.filesUploaded.dni = en.dniFile;
                    SafeHTML.set(document.getElementById('dni_preview_link'), `<i class="fas fa-check-circle"></i> Archivo guardado: <a href="/${en.dniFile}" target="_blank" class="text-success">Ver Documento</a>`);
                }
                if (en.dniBackFile) {
                    this.filesUploaded.dniReverso = en.dniBackFile;
                    SafeHTML.set(document.getElementById('dni_reverso_preview_link'), `<i class="fas fa-check-circle"></i> Archivo guardado: <a href="/${en.dniBackFile}" target="_blank" class="text-success">Ver Documento</a>`);
                }

                // Hydrate contact details
                document.getElementById('email').value = en.email || '';
                document.getElementById('telefono').value = en.telefono || '';
                document.getElementById('direccion').value = en.direccion || '';
                document.getElementById('localidad').value = en.localidad || '';
                document.getElementById('provincia').value = en.provincia || '';
                document.getElementById('codigo_postal').value = en.codigoPostal || '';
                document.getElementById('pais').value = en.pais || '';

                // Hydrate tutor details
                document.getElementById('nombreTutor').value = en.tutorNombre || '';
                document.getElementById('telefonoTutor').value = en.tutorTelefono || '';
                document.getElementById('dniTutor').value = en.tutorDni || '';
                document.getElementById('emailTutor').value = en.tutorEmail || '';
                document.getElementById('direccionTutor').value = en.tutorDireccion || '';
                document.getElementById('codigoPostalTutor').value = en.tutorCodigoPostal || '';
                document.getElementById('municipioTutor').value = en.tutorMunicipio || '';
                document.getElementById('provinciaTutor').value = en.tutorProvincia || '';
                document.getElementById('paisTutor').value = en.tutorPais || '';

                // Hydrate presentacion details
                document.getElementById('presentacionTexto').value = en.presentacionText || '';
                if (en.presentacionFile) {
                    this.filesUploaded.presentacion = en.presentacionFile;
                    SafeHTML.set(document.getElementById('presentacion_preview_link'), `<i class="fas fa-check-circle"></i> Archivo guardado: <a href="/${en.presentacionFile}" target="_blank" class="text-success">Ver Carta</a>`);
                }

                // Hydrate estudios details
                document.getElementById('estudiosTexto').value = en.estudiosText || '';
                if (en.estudiosFile) {
                    this.filesUploaded.estudios = en.estudiosFile;
                    SafeHTML.set(document.getElementById('estudios_preview_link'), `<i class="fas fa-check-circle"></i> Archivo guardado: <a href="/${en.estudiosFile}" target="_blank" class="text-success">Ver Estudios</a>`);
                }

                // Hydrate payment files if exists
                if (en.justificantePagoFile) this.filesUploaded.justificantePago = en.justificantePagoFile;
                if (en.dniFrontalFile) this.filesUploaded.dniFrontal = en.dniFrontalFile;
                if (en.dniTraseraFile) this.filesUploaded.dniTrasera = en.dniTraseraFile;
                if (en.solicitudFraccionadoFile) this.filesUploaded.solicitudFraccionado = en.solicitudFraccionadoFile;
                if (en.declaracionIngresosFile) this.filesUploaded.declaracionIngresos = en.declaracionIngresosFile;
                if (en.paymentMonths) this.paymentMonths = en.paymentMonths;

                if (en.status !== 'draft') {
                    this.lockFormReadOnly(en);
                    if (en.status === 'payment' && typeof this.showTab === 'function') {
                        const visible = Array.from(document.querySelectorAll('#matriculaTabs .tab-item')).filter(t => t.style.display !== 'none');
                        this.showTab(visible.length - 1);
                    }
                }
                
                this.updateStepIndicators();
            }
        } catch (e) {
            console.error('Error hydrating enrollment details:', e);
        }
    },

    lockFormReadOnly(en) {
        this.isLocked = true;
        if (en.status === 'payment') {
            this.isPaymentActive = true;
            document.querySelectorAll('#pane-0 input, #pane-0 select, #pane-0 textarea, #pane-0 button, #pane-1 input, #pane-1 select, #pane-1 textarea, #pane-1 button, #pane-2 input, #pane-2 select, #pane-2 textarea, #pane-2 button, #pane-3 input, #pane-3 select, #pane-3 textarea, #pane-3 button').forEach(el => {
                el.disabled = true;
            });
            const guardarBtn = document.getElementById('guardarBtn');
            if (guardarBtn) guardarBtn.style.display = 'none';
            const completarBtn = document.getElementById('completarBtn');
            if (completarBtn) completarBtn.style.display = 'none';
            const activarCamaraBtn = document.getElementById('activarCamaraBtn');
            if (activarCamaraBtn) activarCamaraBtn.style.display = 'none';

            const pane4 = document.getElementById('pane-4');

            if (en.paymentType) {
                SafeHTML.set(pane4, `
                    <div class="alert-success-locked animate__animated animate__zoomIn" style="text-align: center; padding: 3rem 1.5rem; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 12px; margin-top: 1rem; color: #166534;">
                        <i class="fas fa-check-circle" style="font-size: 3rem; color: #15803d; margin-bottom: 1rem;"></i>
                        <h3 style="margin: 0 0 0.5rem 0; font-size: 1.25rem; font-weight: 700; color: #15803d;">DOCUMENTACIÓN DE PAGO ENVIADA</h3>
                        <p style="margin: 0; font-size: 0.95rem; color: #1e3a1e;">Tu documentación de pago (${en.paymentType === 'unico' ? 'Pago Único' : `Pago Fraccionado - ${en.paymentMonths} meses`}) ha sido recibida y está en proceso de verificación por la secretaría.</p>
                    </div>
                `);
            } else {
                SafeHTML.set(pane4, `
                    <div class="payment-section-wrapper" style="font-family: inherit; background: white; padding: 1.15rem 1.25rem; border: 1px solid var(--dnr-line, #e2e8f0); border-radius: 10px; margin-top: 0.75rem;">
                        <h3 style="border-bottom: 1px solid var(--dnr-line, #e2e8f0); padding-bottom: 0.5rem; margin: 0 0 1rem 0; display: flex; align-items: center; gap: 8px; font-weight: 700; color: var(--dnr-ink, #0f172a); font-size: 1.15rem; font-family: var(--dnr-display, 'Outfit', sans-serif);">
                            <i class="fas fa-credit-card" style="color:var(--dnr-teal-600, #14867A);"></i> Pago y Formalización
                        </h3>

                        <div class="payment-tabs-nav" style="display: flex; gap: 6px; margin-bottom: 1rem; border-bottom: 1px solid var(--dnr-line, #e2e8f0);">
                            <button type="button" class="pay-tab-btn active" data-pay-tab="unico" ${UIEvents.attr("click", function(event,captured){InscripcionView.switchPaymentTab('unico');}, [])} style="background: white; border: 1px solid var(--dnr-teal-500, #1CA093); border-bottom: none; padding: 0.45rem 1rem; border-top-left-radius: 6px; border-top-right-radius: 6px; font-weight: 700; cursor: pointer; color: var(--dnr-teal-700, #0E6B62); transition: all 0.15s; font-size:0.84rem; font-family: var(--dnr-display, 'Outfit', sans-serif);">Pago único</button>
                            <button type="button" class="pay-tab-btn" data-pay-tab="fraccionado" ${UIEvents.attr("click", function(event,captured){InscripcionView.switchPaymentTab('fraccionado');}, [])} style="background: var(--dnr-surface-sunken, #f8fafc); border: 1px solid transparent; border-bottom: none; padding: 0.45rem 1rem; border-top-left-radius: 6px; border-top-right-radius: 6px; font-weight: 600; cursor: pointer; color: var(--dnr-ink-mute, #64748b); transition: all 0.15s; font-size:0.84rem; font-family: var(--dnr-display, 'Outfit', sans-serif);">Pago fraccionado</button>
                        </div>

                        <div id="payment-tab-unico" class="payment-tab-content" style="display: block;">
                            <div style="background: var(--dnr-surface-sunken, #f8fafc); border: 1px solid var(--dnr-line, #e2e8f0); border-radius: 8px; padding: 0.9rem 1.15rem;">
                                <div style="display: flex; align-items: center; gap: 0.75rem; margin-bottom: 0.65rem;">
                                    ${SchoolService.logoHtml('logoLightUrl', 'style="max-height: 32px; background: var(--dnr-teal-700, #0E6B62); color: #fff; font-weight: 800; padding: 5px; border-radius: 6px;"')}
                                    <span style="font-weight: 700; color: var(--dnr-ink, #0f172a); font-size: 0.9rem; font-family: var(--dnr-display, 'Outfit', sans-serif);">Justificante de Pago</span>
                                </div>
                                <p style="margin: 0 0 0.65rem 0; font-size: 0.82rem; color: var(--dnr-ink-mute, #475569); line-height: 1.45;">
                                    Realice una transferencia bancaria o ingreso en ventanilla por un total de <strong>5000 €</strong> a la siguiente cuenta:
                                </p>
                                <div style="background: white; border: 1px solid var(--dnr-line, #e2e8f0); border-radius: 6px; padding: 0.6rem 0.85rem; font-size: 0.8rem; margin-bottom: 0.65rem; line-height: 1.5; font-family: var(--dnr-mono, monospace);">
                                    <div><strong>Entidad:</strong> Rural Kutxa</div>
                                    <div><strong>IBAN:</strong> ES88 3008 0276 2243 6331 4321</div>
                                    <div><strong>Destinatario:</strong> Zinema Escola Koop Elk Txikia</div>
                                </div>
                                <p style="margin: 0 0 0.85rem 0; font-size: 0.75rem; color: var(--dnr-ink-faint, #64748b); font-style: italic;">
                                    Por favor, especifica en el concepto <strong>nombre y apellidos</strong> del alumno/a y el curso que va a realizar.
                                </p>

                                <div class="form-group" style="margin-bottom: 0.75rem;">
                                    <label style="display: block; font-size: 0.8rem; font-weight: 600; margin-bottom: 0.35rem; color: var(--dnr-ink-mute, #475569);">Subir justificante de pago (archivo PDF o imagen)</label>
                                    <div class="upload-zone" id="zone-justificantePago" style="border: 1.5px dashed var(--dnr-line, #cbd5e1); border-radius: 8px; padding: 1rem; text-align: center; background: white; cursor: pointer; transition: border-color 0.2s;">
                                        <input type="file" id="justificantePago" accept="image/*,application/pdf" style="display: none;" ${UIEvents.attr("change", function(event,captured){InscripcionView.handlePaymentFileUpload(this,'justificantePago','justificante_preview_link');}, [])}>
                                        <label for="justificantePago" style="cursor: pointer; display: block; margin: 0;">
                                            <i class="fas fa-file-invoice-dollar" style="font-size: 1.4rem; color: var(--dnr-teal-600, #14867A); margin-bottom: 0.35rem;"></i>
                                            <span style="display: block; font-size: 0.82rem; font-weight: 600; color: var(--dnr-ink, #0f172a);">Seleccionar archivo</span>
                                            <span style="display: block; font-size: 0.7rem; color: var(--dnr-ink-faint, #64748b); margin-top: 2px;">Ningún archivo seleccionado</span>
                                        </label>
                                        <div id="justificante_preview_link" style="margin-top: 0.5rem; font-size: 0.8rem;"></div>
                                    </div>
                                </div>

                                <button type="button" ${UIEvents.attr("click", function(event,captured){InscripcionView.submitPaymentDetails('unico');}, [])} class="btn" style="background: var(--dnr-teal-600, #14867A); color: white; font-weight: 700; border: none; padding: 0.55rem 1.25rem; border-radius: 6px; cursor: pointer; display: flex; align-items: center; gap: 8px; font-size: 0.84rem; box-shadow: 0 2px 4px rgba(20, 134, 122, 0.2); font-family: var(--dnr-display, 'Outfit', sans-serif);">
                                    <i class="fas fa-upload"></i> Enviar justificante
                                </button>
                            </div>
                        </div>

                        <div id="payment-tab-fraccionado" class="payment-tab-content" style="display: none;">
                            <div style="background: var(--dnr-surface-sunken, #f8fafc); border: 1px solid var(--dnr-line, #e2e8f0); border-radius: 8px; padding: 0.9rem 1.15rem;">
                                <p style="margin: 0 0 0.65rem 0; font-size: 0.78rem; color: #7f1d1d; background: #fee2e2; border-left: 3px solid #f87171; padding: 0.6rem 0.75rem; border-radius: 4px; line-height: 1.4;">
                                    <strong>Importante:</strong> Toda la información y documentación subida en esta sección debe corresponder <strong>exclusivamente a la persona que va a financiar los estudios y no al alumno</strong>.
                                </p>
                                <p style="margin: 0 0 0.85rem 0; font-size: 0.82rem; color: var(--dnr-ink-mute, #475569); line-height: 1.45;">
                                    Descarga el documento de solicitud de pago fraccionado haciendo <a href="/assets/docs/solicitud_pago_fraccionado.pdf" target="_blank" style="color: #ef4444; font-weight: 600; text-decoration: underline;">click aquí <i class="fas fa-file-pdf"></i></a>. Una vez lo tengas completado deberás subirlo a la plataforma junto con el resto de documentación.
                                </p>

                                <div style="margin-bottom: 0.85rem;">
                                    <label style="display: block; font-size: 0.8rem; font-weight: 600; margin-bottom: 0.35rem; color: var(--dnr-ink-mute, #475569);">Plazo de financiación</label>
                                    <div style="display: flex; gap: 8px;">
                                        <button type="button" class="months-btn active" ${UIEvents.attr("click", function(event,captured){InscripcionView.selectPaymentMonths(6);}, [])} id="months-btn-6" style="background: var(--dnr-teal-600, #14867A); color: white; border: 1px solid var(--dnr-teal-600, #14867A); padding: 0.35rem 0.75rem; border-radius: 6px; font-weight: 600; cursor: pointer; font-size: 0.78rem; transition: all 0.15s; font-family: var(--dnr-mono, monospace);">6 meses</button>
                                        <button type="button" class="months-btn" ${UIEvents.attr("click", function(event,captured){InscripcionView.selectPaymentMonths(9);}, [])} id="months-btn-9" style="background: white; color: var(--dnr-teal-700, #0E6B62); border: 1px solid var(--dnr-line, #cbd5e1); padding: 0.35rem 0.75rem; border-radius: 6px; font-weight: 600; cursor: pointer; font-size: 0.78rem; transition: all 0.15s; font-family: var(--dnr-mono, monospace);">9 meses</button>
                                        <button type="button" class="months-btn" ${UIEvents.attr("click", function(event,captured){InscripcionView.selectPaymentMonths(12);}, [])} id="months-btn-12" style="background: white; color: var(--dnr-teal-700, #0E6B62); border: 1px solid var(--dnr-line, #cbd5e1); padding: 0.35rem 0.75rem; border-radius: 6px; font-weight: 600; cursor: pointer; font-size: 0.78rem; transition: all 0.15s; font-family: var(--dnr-mono, monospace);">12 meses</button>
                                    </div>
                                </div>

                                <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 0.75rem; margin-bottom: 0.75rem;">
                                    <div class="form-group" style="margin-bottom: 0;">
                                        <label style="display: block; font-size: 0.76rem; font-weight: 600; margin-bottom: 0.3rem; color: var(--dnr-ink-mute, #475569);">DNI – Cara frontal</label>
                                        <div class="upload-zone" id="zone-dniFrontal" style="border: 1px dashed var(--dnr-line, #cbd5e1); border-radius: 6px; padding: 0.6rem; text-align: center; background: white; cursor: pointer;">
                                            <input type="file" id="dniFrontal" accept="image/*,application/pdf" style="display: none;" ${UIEvents.attr("change", function(event,captured){InscripcionView.handlePaymentFileUpload(this,'dniFrontal','dni_front_preview_link');}, [])}>
                                            <label for="dniFrontal" style="cursor: pointer; display: block; margin: 0;">
                                                <span style="font-size: 0.75rem; background: #e2e8f0; padding: 4px 8px; border-radius: 4px; border: 1px solid #cbd5e1; font-weight:600; color:#475569;">Seleccionar archivo</span>
                                                <span style="display: block; font-size: 0.7rem; color: #64748b; margin-top: 6px;">Ningún archivo seleccionado</span>
                                            </label>
                                            <div id="dni_front_preview_link" style="margin-top: 0.5rem; font-size: 0.8rem;"></div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label style="display: block; font-size: 0.8rem; font-weight: 600; margin-bottom: 0.4rem; color: #475569;">DNI – Cara trasera</label>
                                        <div class="upload-zone" id="zone-dniTrasera" style="border: 1px dashed #cbd5e1; border-radius: 6px; padding: 0.75rem; text-align: center; background: white; cursor: pointer;">
                                            <input type="file" id="dniTrasera" accept="image/*,application/pdf" style="display: none;" ${UIEvents.attr("change", function(event,captured){InscripcionView.handlePaymentFileUpload(this,'dniTrasera','dni_back_preview_link');}, [])}>
                                            <label for="dniTrasera" style="cursor: pointer; display: block; margin: 0;">
                                                <span style="font-size: 0.75rem; background: #e2e8f0; padding: 4px 8px; border-radius: 4px; border: 1px solid #cbd5e1; font-weight:600; color:#475569;">Seleccionar archivo</span>
                                                <span style="display: block; font-size: 0.7rem; color: #64748b; margin-top: 6px;">Ningún archivo seleccionado</span>
                                            </label>
                                            <div id="dni_back_preview_link" style="margin-top: 0.5rem; font-size: 0.8rem;"></div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group" style="margin-bottom: 1.25rem;">
                                    <label style="display: block; font-size: 0.8rem; font-weight: 600; margin-bottom: 0.4rem; color: #475569;">Solicitud pago fraccionado completada</label>
                                    <div class="upload-zone" id="zone-solicitudFraccionado" style="border: 1px dashed #cbd5e1; border-radius: 6px; padding: 0.75rem; text-align: center; background: white; cursor: pointer;">
                                        <input type="file" id="solicitudFraccionado" accept="image/*,application/pdf" style="display: none;" ${UIEvents.attr("change", function(event,captured){InscripcionView.handlePaymentFileUpload(this,'solicitudFraccionado','solicitud_preview_link');}, [])}>
                                        <label for="solicitudFraccionado" style="cursor: pointer; display: block; margin: 0;">
                                            <span style="font-size: 0.75rem; background: #e2e8f0; padding: 4px 8px; border-radius: 4px; border: 1px solid #cbd5e1; font-weight:600; color:#475569;">Seleccionar archivo</span>
                                            <span style="display: block; font-size: 0.7rem; color: #64748b; margin-top: 6px;">Ningún archivo seleccionado</span>
                                        </label>
                                        <div id="solicitud_preview_link" style="margin-top: 0.5rem; font-size: 0.8rem;"></div>
                                    </div>
                                </div>

                                <div class="form-group" style="margin-bottom: 1rem;">
                                    <label style="display: block; font-size: 0.8rem; font-weight: 600; margin-bottom: 0.25rem; color: #475569;">Declaración Ingresos</label>
                                    <p style="margin: 0 0 0.4rem 0; font-size: 0.7rem; color: #64748b;">Según tu situación necesitamos lo siguiente:</p>
                                    <div style="font-size: 0.75rem; line-height: 1.5; color: #475569; margin-bottom: 0.75rem; background: white; border: 1px solid #e2e8f0; padding: 0.5rem 0.75rem; border-radius: 6px;">
                                        <div>✔️ <strong>ASALARIADOS:</strong> Última nómina</div>
                                        <div>✔️ <strong>PENSIONISTA:</strong> Certificado o resguardo de pensión</div>
                                        <div>✔️ <strong>AUTÓNOMO:</strong> Última declaración de renta (Mod 100)</div>
                                    </div>
                                    <div class="upload-zone" id="zone-declaracionIngresos" style="border: 1px dashed #cbd5e1; border-radius: 6px; padding: 0.75rem; text-align: center; background: white; cursor: pointer;">
                                        <input type="file" id="declaracionIngresos" accept="image/*,application/pdf" style="display: none;" ${UIEvents.attr("change", function(event,captured){InscripcionView.handlePaymentFileUpload(this,'declaracionIngresos','declaracion_preview_link');}, [])}>
                                        <label for="declaracionIngresos" style="cursor: pointer; display: block; margin: 0;">
                                            <span style="font-size: 0.75rem; background: #e2e8f0; padding: 4px 8px; border-radius: 4px; border: 1px solid #cbd5e1; font-weight:600; color:#475569;">Seleccionar archivo</span>
                                            <span style="display: block; font-size: 0.7rem; color: #64748b; margin-top: 6px;">Ningún archivo seleccionado</span>
                                        </label>
                                        <div id="declaracion_preview_link" style="margin-top: 0.5rem; font-size: 0.8rem;"></div>
                                    </div>
                                </div>

                                <button type="button" ${UIEvents.attr("click", function(event,captured){InscripcionView.submitPaymentDetails('fraccionado');}, [])} class="btn" style="background: #eab308; color: #0f172a; font-weight: 700; border: none; padding: 0.7rem 1.5rem; border-radius: 6px; cursor: pointer; display: flex; align-items: center; gap: 8px; margin-top: 1.25rem; font-size: 0.85rem; box-shadow: 0 1px 2px rgba(0,0,0,0.05); font-family:inherit;">
                                    <i class="fas fa-upload"></i> Enviar documentación
                                </button>
                            </div>
                        </div>
                    </div>
                `);
            }
            return;
        }

        // Disable all inputs, textareas, selects, files
        document.querySelectorAll('input, select, textarea, button').forEach(el => {
            if (el.id !== 'prevBtn' && el.id !== 'nextBtn') {
                el.disabled = true;
            }
        });

        // Hide buttons
        const gBtn = document.getElementById('guardarBtn');
        if (gBtn) gBtn.style.display = 'none';
        const cBtn = document.getElementById('completarBtn');
        if (cBtn) cBtn.style.display = 'none';
        const aBtn = document.getElementById('activarCamaraBtn');
        if (aBtn) aBtn.style.display = 'none';
        
        // Show success summary in pane-4
        const pane4 = document.getElementById('pane-4');
        SafeHTML.set(pane4, `
            <div class="alert-success-locked animate__animated animate__zoomIn">
                <i class="fas fa-lock" style="font-size: 3rem; color: #10b981; margin-bottom: 1rem;"></i>
                <h3>MATRÍCULA FINALIZADA Y ENVIADA</h3>
                <p>Tu solicitud de matrícula ha sido enviada correctamente el <b>${new Date(en.updatedAt).toLocaleDateString()}</b>.</p>
                Token de referencia: <code>${en.token}</code></p>
                <p style="font-size: 0.85rem; color: #94a3b8; margin-top: 1rem;">Puedes guardar este token de referencia para realizar el seguimiento o consultas con la secretaría de la escuela.</p>
            </div>
            
            <style ${SafeHTML.styleAttr}>
                .alert-success-locked {
                    background: rgba(16, 185, 129, 0.05);
                    border: 1px solid rgba(16, 185, 129, 0.2);
                    border-radius: 12px;
                    padding: 2.5rem;
                    text-align: center;
                    color: var(--text-primary);
                    margin-top: 1rem;
                }
                .alert-success-locked h3 {
                    color: #10b981;
                    font-weight: 700;
                    margin-top: 0;
                    letter-spacing: 1px;
                }
                .alert-success-locked p {
                    color: var(--text-secondary);
                    line-height: 1.5;
                }
            </style>
        `);
    },

    updateStepIndicators() {
        const tabs = document.querySelectorAll('#matriculaTabs .tab-item');
        const getVisibleTabs = () => {
            return Array.from(tabs).filter(t => t.style.display !== 'none');
        };
        const visible = getVisibleTabs();
        
        visible.forEach((tab) => {
            const paneIndex = parseInt(tab.dataset.tab);
            const isValid = this.isPaneValid(paneIndex);
            
            if (isValid) {
                tab.classList.add('completed');
            } else {
                tab.classList.remove('completed');
            }
        });
    },

    isPaneValid(paneIndex) {
        if (paneIndex === 0) {
            const selectTipo = document.getElementById("tipo_formation");
            const selectFormation = document.getElementById("formation_id");
            const inputDiplomaId = document.getElementById("formation_id_diploma");
            const tipoFormacion = selectTipo ? selectTipo.value : '';
            const formationId = this.ranksPreferences(tipoFormacion) ? (inputDiplomaId ? inputDiplomaId.value : '') : (selectFormation ? selectFormation.value : '');
            
            if (!tipoFormacion || !formationId) return false;
            
            const fields = ['nombre', 'apellidos', 'dni', 'fecha_nacimiento', 'sexo'];
            for (let f of fields) {
                const el = document.getElementById(f);
                if (!el || !el.value.trim()) return false;
            }
            
            if (!this.filesUploaded.dni || !this.filesUploaded.dniReverso) return false;
            if (!this.filesUploaded.foto && (!document.getElementById('fotoBase64') || !document.getElementById('fotoBase64').value)) return false;
            
            return true;
        }
        
        if (paneIndex === 1) {
            const dob = document.getElementById('fecha_nacimiento') ? document.getElementById('fecha_nacimiento').value : '';
            const isMinor = dob && (new Date().getFullYear() - new Date(dob).getFullYear()) < 18;
            if (!isMinor) return true;
            
            const tutorFields = ['nombreTutor', 'telefonoTutor', 'dniTutor', 'emailTutor', 'direccionTutor', 'codigoPostalTutor', 'municipioTutor', 'provinciaTutor', 'paisTutor'];
            for (let f of tutorFields) {
                const el = document.getElementById(f);
                if (!el || !el.value.trim()) return false;
            }
            return true;
        }
        
        if (paneIndex === 2) {
            const contactFields = ['email', 'telefono', 'direccion', 'localidad', 'provincia', 'codigo_postal', 'pais'];
            for (let f of contactFields) {
                const el = document.getElementById(f);
                if (!el || !el.value.trim()) return false;
            }
            return true;
        }
        
        if (paneIndex === 3) {
            const presTexto = document.getElementById('presentacionTexto');
            const hasPres = (presTexto && presTexto.value.trim()) || this.filesUploaded.presentacion;
            
            const estTexto = document.getElementById('estudiosTexto');
            const hasEst = (estTexto && estTexto.value.trim()) || this.filesUploaded.estudios;
            
            return !!(hasPres && hasEst);
        }
        
        if (paneIndex === 4) {
            const privacidad = document.getElementById('privacidadCheck');
            const normas = document.getElementById('normasCheck');
            return !!(privacidad && privacidad.checked && normas && normas.checked);
        }
        
        return false;
    },

    validateAndHighlightAll() {
        let missing = [];
        
        const checkField = (id, displayName) => {
            const el = document.getElementById(id);
            if (!el) return;
            if (!el.value.trim()) {
                el.classList.add('is-invalid');
                missing.push(displayName);
            } else {
                el.classList.remove('is-invalid');
            }
        };

        const selectTipo = document.getElementById("tipo_formation");
        const selectFormation = document.getElementById("formation_id");
        const inputDiplomaId = document.getElementById("formation_id_diploma");
        const tipoFormacion = selectTipo ? selectTipo.value : '';
        const formationId = this.ranksPreferences(tipoFormacion) ? (inputDiplomaId ? inputDiplomaId.value : '') : (selectFormation ? selectFormation.value : '');

        if (!tipoFormacion) {
            selectTipo.classList.add('is-invalid');
            missing.push('Tipo de Formación (Pestaña Datos Personales)');
        } else {
            selectTipo.classList.remove('is-invalid');
        }

        if (this.ranksPreferences(tipoFormacion)) {
            const dndContainer = document.getElementById("dnd_container");
            if (!formationId) {
                if (dndContainer) dndContainer.classList.add('is-invalid');
                missing.push('Orden de preferencias (Pestaña Datos Personales)');
            } else {
                if (dndContainer) dndContainer.classList.remove('is-invalid');
            }
        } else {
            if (!formationId) {
                selectFormation.classList.add('is-invalid');
                missing.push('Curso de Formación (Pestaña Datos Personales)');
            } else {
                selectFormation.classList.remove('is-invalid');
            }
        }

        checkField('nombre', 'Nombre (Pestaña Datos Personales)');
        checkField('apellidos', 'Apellidos (Pestaña Datos Personales)');
        checkField('dni', 'DNI / NIE / Pasaporte (Pestaña Datos Personales)');
        checkField('fecha_nacimiento', 'Fecha de Nacimiento (Pestaña Datos Personales)');
        checkField('sexo', 'Sexo (Pestaña Datos Personales)');

        // Both sides of the ID document.
        for (const [field, zoneId, label] of [['dni', 'zone-dni_subido', 'DNI · anverso'], ['dniReverso', 'zone-dni_reverso', 'DNI · reverso']]) {
            const zone = document.getElementById(zoneId);
            if (!this.filesUploaded[field]) {
                if (zone) zone.classList.add('is-invalid');
                missing.push(`${label} (Pestaña Datos Personales)`);
            } else if (zone) {
                zone.classList.remove('is-invalid');
            }
        }

        const fotoZone = document.getElementById('zone-foto_subida');
        const fotoBase64 = document.getElementById('fotoBase64') ? document.getElementById('fotoBase64').value : '';
        if (!this.filesUploaded.foto && !fotoBase64) {
            if (fotoZone) fotoZone.classList.add('is-invalid');
            missing.push('Foto de perfil (Pestaña Datos Personales)');
        } else {
            if (fotoZone) fotoZone.classList.remove('is-invalid');
        }

        const dob = document.getElementById('fecha_nacimiento') ? document.getElementById('fecha_nacimiento').value : '';
        const isMinor = dob && (new Date().getFullYear() - new Date(dob).getFullYear()) < 18;
        if (isMinor) {
            checkField('nombreTutor', 'Nombre del Tutor (Pestaña Datos del Tutor)');
            checkField('telefonoTutor', 'Teléfono del Tutor (Pestaña Datos del Tutor)');
            checkField('dniTutor', 'DNI del Tutor (Pestaña Datos del Tutor)');
            checkField('emailTutor', 'Email del Tutor (Pestaña Datos del Tutor)');
            checkField('direccionTutor', 'Dirección del Tutor (Pestaña Datos del Tutor)');
            checkField('codigoPostalTutor', 'Código postal del Tutor (Pestaña Datos del Tutor)');
            checkField('municipioTutor', 'Municipio del Tutor (Pestaña Datos del Tutor)');
            checkField('provinciaTutor', 'Provincia del Tutor (Pestaña Datos del Tutor)');
            checkField('paisTutor', 'País del Tutor (Pestaña Datos del Tutor)');
        } else {
            const tutorFields = ['nombreTutor', 'telefonoTutor', 'dniTutor', 'emailTutor', 'direccionTutor', 'codigoPostalTutor', 'municipioTutor', 'provinciaTutor', 'paisTutor'];
            tutorFields.forEach(f => {
                const el = document.getElementById(f);
                if (el) el.classList.remove('is-invalid');
            });
        }

        checkField('email', 'Email (Pestaña Datos de Contacto)');
        checkField('telefono', 'Teléfono (Pestaña Datos de Contacto)');
        checkField('direccion', 'Dirección Postal (Pestaña Datos de Contacto)');
        checkField('localidad', 'Localidad / Municipio (Pestaña Datos de Contacto)');
        checkField('provincia', 'Provincia (Pestaña Datos de Contacto)');
        checkField('codigo_postal', 'Código Postal (Pestaña Datos de Contacto)');
        checkField('pais', 'País (Pestaña Datos de Contacto)');

        const presTexto = document.getElementById('presentacionTexto');
        const presZone = document.getElementById('zone-hablanos_documento');
        const hasPres = (presTexto && presTexto.value.trim()) || this.filesUploaded.presentacion;
        if (!hasPres) {
            if (presTexto) presTexto.classList.add('is-invalid');
            if (presZone) presZone.classList.add('is-invalid');
            missing.push('Carta de Presentación o archivo adjunto (Pestaña Presentación)');
        } else {
            if (presTexto) presTexto.classList.remove('is-invalid');
            if (presZone) presZone.classList.remove('is-invalid');
        }

        const estTexto = document.getElementById('estudiosTexto');
        const estZone = document.getElementById('zone-estudiosArchivo');
        const hasEst = (estTexto && estTexto.value.trim()) || this.filesUploaded.estudios;
        if (!hasEst) {
            if (estTexto) estTexto.classList.add('is-invalid');
            if (estZone) estZone.classList.add('is-invalid');
            missing.push('Estudios Académicos o archivo adjunto (Pestaña Presentación)');
        } else {
            if (estTexto) estTexto.classList.remove('is-invalid');
            if (estZone) estZone.classList.remove('is-invalid');
        }

        const privacidad = document.getElementById('privacidadCheck');
        const normas = document.getElementById('normasCheck');
        if (privacidad && !privacidad.checked) {
            privacidad.classList.add('is-invalid');
            missing.push('Aceptación de la política de privacidad (Pestaña Pago y Envío)');
        } else if (privacidad) {
            privacidad.classList.remove('is-invalid');
        }

        if (normas && !normas.checked) {
            normas.classList.add('is-invalid');
            missing.push('Aceptación de la normativa oficial (Pestaña Pago y Envío)');
        } else if (normas) {
            normas.classList.remove('is-invalid');
        }

        return missing;
    },

    async saveEnrollment(cerrar = false) {
        const selectTipo = document.getElementById("tipo_formation");
        const selectFormation = document.getElementById("formation_id");
        const inputDiplomaId = document.getElementById("formation_id_diploma");
        const email = document.getElementById('email').value.trim();

        // 1. Basic checks for draft save
        if (!email) {
            SafeHTML.fire('Email Requerido', 'Introduce tu email en la pestaña "Datos de Contacto" para poder guardar el borrador.', 'warning');
            return;
        }

        const tipoFormacion = selectTipo.value;
        const formationId = this.ranksPreferences(tipoFormacion) ? inputDiplomaId.value : selectFormation.value;

        if (!tipoFormacion || !formationId) {
            SafeHTML.fire('Selecciona Curso', 'Elige el Tipo de Formación y la Formación en la sección superior antes de guardar.', 'warning');
            return;
        }

        // 2. Extra validations if completing enrollment (cerrar = true)
        if (cerrar) {
            const missing = this.validateAndHighlightAll();

            if (missing.length > 0) {
                SafeHTML.fire({
                    icon: 'warning',
                    title: 'Datos Incompletos',
                    html: `<p>Faltan los siguientes campos obligatorios para enviar la matrícula:</p>
                           <ul style="text-align: left; font-size: 0.85rem; max-height: 200px; overflow-y: auto;">
                               ${missing.map(m => `<li>${m}</li>`).join('')}
                           </ul>`,
                    confirmButtonText: 'Entendido'
                });
                
                // Jump to the first tab that has an invalid field to help the user
                const visibleTabs = Array.from(document.querySelectorAll('#matriculaTabs .tab-item')).filter(t => t.style.display !== 'none');
                for (let tab of visibleTabs) {
                    const paneIndex = parseInt(tab.dataset.tab);
                    if (!this.isPaneValid(paneIndex)) {
                        tab.click();
                        break;
                    }
                }
                return;
            }
        }

        // 3. Confirm close
        if (cerrar) {
            const confirmResult = await SafeHTML.fire({
                title: '¿Confirmas el envío de tu matrícula?',
                text: 'Una vez finalizada la solicitud, no podrás editar sus contenidos ni subir más documentos.',
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#10b981',
                cancelButtonColor: '#64748b',
                confirmButtonText: 'Sí, enviar matrícula',
                cancelButtonText: 'Cancelar'
            });
            if (!confirmResult.isConfirmed) return;
        }

        // 4. Send request
        try {
            const formData = {
                token: this.token,
                cerrar: cerrar ? 1 : 0,
                tipoFormacion,
                formationId,
                ordenDiplomaturas: document.getElementById('orden_diplomaturas').value,
                nombre: document.getElementById('nombre').value.trim(),
                apellidos: document.getElementById('apellidos').value.trim(),
                dni: document.getElementById('dni').value.trim(),
                fechaNacimiento: document.getElementById('fecha_nacimiento').value,
                sexo: document.getElementById('sexo').value,
                comoNosConociste: document.getElementById('como_nos_conociste').value,
                fotoBase64: document.getElementById('fotoBase64').value || null,
                
                email,
                telefono: document.getElementById('telefono').value.trim(),
                direccion: document.getElementById('direccion').value.trim(),
                localidad: document.getElementById('localidad').value.trim(),
                provincia: document.getElementById('provincia').value,
                codigoPostal: document.getElementById('codigo_postal').value.trim(),
                pais: document.getElementById('pais').value.trim(),

                tutorNombre: document.getElementById('nombreTutor').value.trim(),
                tutorTelefono: document.getElementById('telefonoTutor').value.trim(),
                tutorDni: document.getElementById('dniTutor').value.trim(),
                tutorEmail: document.getElementById('emailTutor').value.trim(),
                tutorDireccion: document.getElementById('direccionTutor').value.trim(),
                tutorCodigoPostal: document.getElementById('codigoPostalTutor').value.trim(),
                tutorMunicipio: document.getElementById('municipioTutor').value.trim(),
                tutorProvincia: document.getElementById('provinciaTutor').value,
                tutorPais: document.getElementById('paisTutor').value.trim(),

                presentacionText: document.getElementById('presentacionTexto').value.trim(),
                estudiosText: document.getElementById('estudiosTexto').value.trim(),
                dniFile: InscripcionView.filesUploaded.dni || null,
                dniBackFile: InscripcionView.filesUploaded.dniReverso || null,
                presentacionFile: InscripcionView.filesUploaded.presentacion || null,
                estudiosFile: InscripcionView.filesUploaded.estudios || null,
                fotoFile: InscripcionView.filesUploaded.foto || null
            };

            SafeHTML.fire({
                title: 'Procesando...',
                html: 'Guardando datos e información de matrícula.',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            const response = await fetch('/api/public/enrollment', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });

            if (!response.ok) {
                const failure = await response.json().catch(() => null);
                throw new Error(response.status === 400 && failure?.error ? failure.error : 'Error al guardar datos');
            }

            const res = await response.json();
            Swal.close();

            if (res.success) {
                if (cerrar) {
                    await SafeHTML.fire({
                        icon: 'success',
                        title: 'Matrícula Completada',
                        text: 'Tu solicitud de matrícula ha sido enviada con éxito. Te mantendremos informado por email.'
                    });
                    window.location.assign('/inscribete');
                } else {
                    const isNew = !this.token;
                    this.token = res.token;
                    for (const [field, key] of Object.entries({ foto: 'foto', dni: 'dniFile', dniReverso: 'dniBackFile', presentacion: 'presentacionFile', estudios: 'estudiosFile' })) {
                        if (res.enrollment?.[key]) this.filesUploaded[field] = res.enrollment[key];
                    }
                    
                    if (isNew) {
                        await SafeHTML.fire({
                            icon: 'info',
                            title: 'Borrador Guardado',
                            html: `<p>Se ha generado un borrador. Guarda tu token para continuar rellenando la matrícula más tarde:</p>
                                   <div style="background: #1e293b; padding: 0.75rem; border-radius: 8px; font-weight: 700; margin: 1rem 0; font-size: 1.25rem; font-family: monospace; letter-spacing: 1px; color: #38bdf8;">
                                       ${Utils.sanitizeHTML(res.token)}
                                   </div>
                                   <p style="font-size: 0.85rem; color: #64748b;">Tu enlace de acceso directo es:<br><a href="/inscribete/${Utils.sanitizeHTML(res.token)}" style="color: #0ea5e9; word-break: break-all;">${Utils.sanitizeHTML(window.location.origin)}/inscribete/${Utils.sanitizeHTML(res.token)}</a></p>`,
                            confirmButtonText: 'Entendido'
                        });
                        history.replaceState(null, '', `/inscribete/${encodeURIComponent(res.token)}`);
                    } else {
                        SafeHTML.fire({
                            icon: 'success',
                            title: 'Borrador actualizado con éxito',
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        });
                        this.hydrateEnrollment(); // Reload values
                    }
                }
            } else {
                throw new Error(res.error || 'Fallo del servidor');
            }
        } catch (err) {
            SafeHTML.fire('Error', err.message || 'Hubo un error al procesar el formulario.', 'error');
        }
    },

    switchPaymentTab(type) {
        // Los botones ya no llevan onclick (CSP + UIEvents): se localizan por data-pay-tab.
        const btnUnico = document.querySelector('.pay-tab-btn[data-pay-tab="unico"]');
        const btnFracc = document.querySelector('.pay-tab-btn[data-pay-tab="fraccionado"]');
        if (!btnUnico || !btnFracc) return;
        const tabUnico = document.getElementById('payment-tab-unico');
        const tabFracc = document.getElementById('payment-tab-fraccionado');

        if (type === 'unico') {
            btnUnico.classList.add('active');
            btnUnico.style.background = 'white';
            btnUnico.style.color = '#0f766e';
            btnUnico.style.borderColor = '#cbd5e1';

            btnFracc.classList.remove('active');
            btnFracc.style.background = '#f8fafc';
            btnFracc.style.color = '#64748b';
            btnFracc.style.borderColor = 'transparent';

            tabUnico.style.display = 'block';
            tabFracc.style.display = 'none';
        } else {
            btnFracc.classList.add('active');
            btnFracc.style.background = 'white';
            btnFracc.style.color = '#0f766e';
            btnFracc.style.borderColor = '#cbd5e1';

            btnUnico.classList.remove('active');
            btnUnico.style.background = '#f8fafc';
            btnUnico.style.color = '#64748b';
            btnUnico.style.borderColor = 'transparent';

            tabUnico.style.display = 'none';
            tabFracc.style.display = 'block';
        }
    },

    selectPaymentMonths(months) {
        this.paymentMonths = months;
        document.querySelectorAll('.months-btn').forEach(btn => {
            btn.classList.remove('active');
            btn.style.background = 'white';
            btn.style.color = 'var(--dnr-teal-700, #0E6B62)';
            btn.style.borderColor = 'var(--dnr-line, #cbd5e1)';
        });
        const activeBtn = document.getElementById(`months-btn-${months}`);
        if (activeBtn) {
            activeBtn.classList.add('active');
            activeBtn.style.background = 'var(--dnr-teal-600, #14867A)';
            activeBtn.style.color = 'white';
            activeBtn.style.borderColor = 'var(--dnr-teal-600, #14867A)';
        }
    },

    async handlePaymentFileUpload(inputEl, fieldName, previewId) {
        const file = inputEl.files[0];
        if (!file) return;

        if (file.size > 20 * 1024 * 1024) {
            SafeHTML.fire('Archivo muy grande', 'El archivo no debe superar los 20MB.', 'error');
            inputEl.value = '';
            return;
        }

        const previewEl = document.getElementById(previewId);
        try {
            SafeHTML.set(previewEl, `<i class="fas fa-spinner fa-spin"></i> Subiendo...`);
            const response = await fetch(`/api/public/enrollment/upload?field=${fieldName}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/octet-stream', 'X-Enrollment-Token': this.token },
                body: file
            });

            if (!response.ok) throw new Error('Subida fallida');
            const res = await response.json();
            if (res.success) {
                this.filesUploaded[fieldName] = res.path;
                SafeHTML.set(previewEl, `<i class="fas fa-check-circle" style="color: #10b981; margin-right: 4px;"></i> Subido: <a href="/${res.path}" target="_blank" style="color: #0f766e; text-decoration: underline; font-weight:600;">Ver archivo</a>`);
                SafeHTML.fire({
                    icon: 'success',
                    title: 'Archivo subido',
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000
                });
            } else {
                throw new Error(res.error || 'Error del servidor');
            }
        } catch (err) {
            console.error(err);
            SafeHTML.set(previewEl, `<span class="text-danger"><i class="fas fa-times-circle"></i> Subida fallida</span>`);
            SafeHTML.fire('Error', 'No se pudo subir el archivo. Reinténtalo.', 'error');
        }
    },

    async submitPaymentDetails(paymentType) {
        if (paymentType === 'unico') {
            if (!this.filesUploaded.justificantePago) {
                SafeHTML.fire('Falta archivo', 'Por favor, sube el justificante de pago antes de continuar.', 'warning');
                return;
            }
        } else {
            if (!this.filesUploaded.dniFrontal || !this.filesUploaded.dniTrasera || !this.filesUploaded.solicitudFraccionado || !this.filesUploaded.declaracionIngresos) {
                SafeHTML.fire('Faltan documentos', 'Por favor, sube todos los documentos obligatorios para el pago fraccionado.', 'warning');
                return;
            }
        }

        try {
            SafeHTML.fire({
                title: 'Enviando...',
                text: 'Guardando tus datos de pago.',
                allowOutsideClick: false,
                didOpen: () => { Swal.showLoading(); }
            });

            const payload = {
                token: this.token,
                paymentType: paymentType,
                paymentMonths: paymentType === 'fraccionado' ? this.paymentMonths : null
            };

            const response = await fetch('/api/public/enrollment/payment', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (!response.ok) throw new Error('Error al enviar los datos de pago');
            const res = await response.json();
            if (res.success) {
                SafeHTML.fire({
                    icon: 'success',
                    title: 'Documentación recibida',
                    text: 'Los datos y documentos de pago se han recibido correctamente. La secretaría procederá a su verificación.',
                    confirmButtonColor: '#0F766E'
                }).then(() => {
                    window.location.reload();
                });
            } else {
                throw new Error(res.error || 'Error del servidor');
            }
        } catch (err) {
            console.error(err);
            SafeHTML.fire('Error', err.message || 'No se pudo guardar la información de pago.', 'error');
        }
    }
};

window.InscripcionView = InscripcionView;
